// Auto-generated from content/blog/*.md
// Run: npm run build:blog
// DO NOT EDIT THIS FILE DIRECTLY

export const blogPosts = [
  {
    "id": 59,
    "slug": "chatgpt-gifs-images-2-6-store-content",
    "title": "ChatGPT makes GIFs now. How to use them on your store without slowing it down",
    "excerpt": "OpenAI's Images 2.6 update, out November 4, 2026, turns a prompt or a photo into an animated GIF inside ChatGPT. We made two and measured them. Four rules before one goes on a product page, a landing page or an email.",
    "author": {
      "name": "José Antonio Mijares",
      "role": "Founder & AI Strategist",
      "avatar": "/images/team/jose-mijares.png",
      "twitter": "@joseamijares"
    },
    "category": "UX",
    "tags": [
      "ChatGPT",
      "AI Images",
      "GIF",
      "Shopify",
      "Page Speed"
    ],
    "publishedAt": "2026-11-05",
    "modifiedAt": "2026-11-05",
    "readingTime": "6 min read",
    "featuredImage": "/images/blog/chatgpt-gifs-images-2-6-store-content-cover.webp",
    "featuredImageSize": {
      "width": 1600,
      "height": 1000
    },
    "figures": [
      {
        "src": "/images/blog/chatgpt-gifs-images-2-6-store-content-rabbit-sheet.webp",
        "alt": "ChatGPT's frame sheet for the rabbit GIF: one image with twelve frames in a grid of four columns and three rows, the rabbit turning from profile to the camera and back",
        "caption": "ChatGPT's Sheet view: all twelve frames of the GIF in one image, so you can check each one before you share it.",
        "width": 1448,
        "height": 1086
      },
      {
        "src": "/images/blog/chatgpt-gifs-images-2-6-store-content-explainer-en.webp",
        "alt": "Four cards under the headline \"Make it in ChatGPT. Ship it light.\": 01 Make, Prompt or photo to GIF, set the speed, fix frames; 02 Convert, GIF to WebP or MP4, 80 to 91% smaller in our tests; 03 First frame, frame one works alone, some inboxes stop there; 04 Motion, stop within 5 seconds, or give a pause button",
        "caption": "Make the GIF in ChatGPT, then ship it as WebP or MP4, with a first frame that stands alone and motion people can stop.",
        "width": 1600,
        "height": 900
      }
    ],
    "seoKeywords": [
      "ChatGPT GIF",
      "ChatGPT Images 2.6",
      "make GIF with ChatGPT",
      "animated product images Shopify",
      "GIF vs MP4 page speed"
    ],
    "faqSchema": [
      {
        "question": "Can ChatGPT make GIFs?",
        "answer": "Yes. Since OpenAI's Images 2.6 update on November 4, 2026, ChatGPT can turn a text prompt or an uploaded image into an animated GIF. You can change the playback speed and edit individual frames before you download or share it."
      },
      {
        "question": "Is the ChatGPT GIF maker free?",
        "answer": "OpenAI's announcement doesn't list plan limits. Early reports say it is rolling out on every plan and counts against your existing image limits, so check your own account."
      },
      {
        "question": "What size are ChatGPT GIFs?",
        "answer": "In our two tests in the ChatGPT web app the GIFs came back square, 358 × 358 and 439 × 439 pixels, with 12 and 8 frames, even though we asked for 16:9. Your results may differ."
      },
      {
        "question": "Should I use a GIF or a video on my website?",
        "answer": "Use a video or animated WebP. Converting our ChatGPT GIFs made them 80 to 91% smaller with the same frames. Keep the GIF only where video isn't supported, such as some email clients."
      },
      {
        "question": "Can developers make GIFs with the API?",
        "answer": "Yes. OpenAI's image generation guide documents GIF output on the Image API, with a frame count and a frame duration you set."
      }
    ],
    "keyTakeaways": []
  },
  {
    "id": 60,
    "slug": "es-chatgpt-gifs-images-2-6-store-content",
    "title": "ChatGPT ya hace GIFs. Cómo usarlos en tu tienda sin hacerla más lenta",
    "excerpt": "La actualización Images 2.6 de OpenAI, del 4 de noviembre de 2026, convierte un prompt o una foto en un GIF animado dentro de ChatGPT. Hicimos dos y los medimos. Cuatro reglas antes de subir uno a una página de producto, una landing o un email.",
    "author": {
      "name": "José Antonio Mijares",
      "role": "Founder & AI Strategist",
      "avatar": "/images/team/jose-mijares.png",
      "twitter": "@joseamijares"
    },
    "category": "UX",
    "tags": [
      "ChatGPT",
      "Imágenes con IA",
      "GIF",
      "Shopify",
      "Velocidad de página"
    ],
    "publishedAt": "2026-11-05",
    "modifiedAt": "2026-11-05",
    "readingTime": "6 min de lectura",
    "featuredImage": "/images/blog/chatgpt-gifs-images-2-6-store-content-cover.webp",
    "featuredImageSize": {
      "width": 1600,
      "height": 1000
    },
    "figures": [
      {
        "src": "/images/blog/chatgpt-gifs-images-2-6-store-content-rabbit-sheet.webp",
        "alt": "La hoja de cuadros de ChatGPT para el GIF del conejo: una imagen con doce cuadros en una cuadrícula de cuatro columnas y tres filas, el conejo girando de perfil hacia la cámara y de regreso",
        "caption": "La vista Sheet de ChatGPT: los doce cuadros del GIF en una imagen, para revisar cada uno antes de compartirlo.",
        "width": 1448,
        "height": 1086
      },
      {
        "src": "/images/blog/chatgpt-gifs-images-2-6-store-content-explainer-es.webp",
        "alt": "Cuatro tarjetas bajo el titular \"Hazlo en ChatGPT. Publícalo ligero.\": 01 Crea, de prompt o foto a GIF, ajusta velocidad y cuadros; 02 Convierte, de GIF a WebP o MP4, 80 a 91% más ligero en pruebas; 03 Primer cuadro, el primero se sostiene solo, algunos correos no pasan de ahí; 04 Movimiento, que pare en 5 segundos, o dale botón de pausa",
        "caption": "Haz el GIF en ChatGPT y publícalo como WebP o MP4, con un primer cuadro que se sostenga solo y un movimiento que se pueda detener.",
        "width": 1600,
        "height": 900
      }
    ],
    "seoKeywords": [
      "GIF con ChatGPT",
      "ChatGPT Images 2.6",
      "cómo hacer un GIF en ChatGPT",
      "imágenes animadas de producto Shopify",
      "GIF o MP4 velocidad de página"
    ],
    "faqSchema": [
      {
        "question": "¿ChatGPT puede hacer GIFs?",
        "answer": "Sí. Desde la actualización Images 2.6 de OpenAI, del 4 de noviembre de 2026, ChatGPT convierte un prompt de texto o una imagen que subas en un GIF animado. Puedes cambiar la velocidad y editar cuadros individuales antes de descargarlo o compartirlo."
      },
      {
        "question": "¿El creador de GIFs de ChatGPT es gratis?",
        "answer": "El anuncio de OpenAI no menciona límites por plan. Los primeros reportes dicen que llega a todos los planes y cuenta contra tus límites de imágenes actuales, así que revisa tu propia cuenta."
      },
      {
        "question": "¿De qué tamaño salen los GIFs de ChatGPT?",
        "answer": "En nuestras dos pruebas en ChatGPT web salieron cuadrados, de 358 × 358 y 439 × 439 píxeles, con 12 y 8 cuadros, aunque pedimos 16:9. Tus resultados pueden variar."
      },
      {
        "question": "¿Uso GIF o video en mi sitio?",
        "answer": "Video o WebP animado. Convertir nuestros GIFs de ChatGPT los hizo entre 80 y 91% más ligeros con los mismos cuadros. Deja el GIF solo donde no hay soporte de video, como algunos clientes de correo."
      },
      {
        "question": "¿Los desarrolladores pueden hacer GIFs con la API?",
        "answer": "Sí. La guía de generación de imágenes de OpenAI documenta la salida en GIF en la Image API, con un número de cuadros y una duración por cuadro que tú defines."
      }
    ],
    "keyTakeaways": []
  },
  {
    "id": 58,
    "slug": "es-shopify-fall-26-ai-agents-setup",
    "title": "La Fall '26 Edition de Shopify abre tu tienda a los agentes de IA. Qué configurar primero",
    "excerpt": "Los agentes de IA ya pueden buscar en tu catálogo de Shopify, llenar un carrito en tu tienda y llevar al comprador a tu checkout. Trabajan con tus datos de producto y tus políticas, así que eso es lo que hay que arreglar. Cinco cosas que revisar esta semana.",
    "author": {
      "name": "José Antonio Mijares",
      "role": "Founder & AI Strategist",
      "avatar": "/images/team/jose-mijares.png",
      "twitter": "@joseamijares"
    },
    "category": "CRO",
    "tags": [
      "Shopify",
      "Shopify Editions",
      "Agentes de IA",
      "Comercio agéntico",
      "Checkout"
    ],
    "publishedAt": "2026-11-03",
    "modifiedAt": "2026-11-03",
    "readingTime": "6 min de lectura",
    "featuredImage": "/images/blog/shopify-fall-26-ai-agents-setup-cover.webp",
    "featuredImageSize": {
      "width": 1600,
      "height": 1000
    },
    "figures": [
      {
        "src": "/images/blog/shopify-fall-26-ai-agents-setup-explainer-es.webp",
        "alt": "Cuatro tarjetas en fila bajo el título \"Los agentes leen tu tienda. Escríbela con datos.\": 01 CATÁLOGO, productos y variantes, nombra cada opción claro; 02 POLÍTICAS, devoluciones, envíos, pagos, días, países, métodos; 03 CARRITO, el carrito de tu tema, prueba un carrito a medida; 04 CHECKOUT, tu checkout, tu pedido, el comprador confirma antes.",
        "caption": "Lo que Shopify abre a los agentes de IA en la Fall '26 Edition, y lo que cada parte lee de tu tienda. Fuente: documentación para desarrolladores de Shopify, noviembre de 2026.",
        "width": 1600,
        "height": 900
      }
    ],
    "seoKeywords": [
      "Shopify Fall 26 Edition",
      "Shopify agentes de IA",
      "comercio agéntico Shopify",
      "Shopify WebMCP",
      "vender en ChatGPT con Shopify"
    ],
    "faqSchema": [
      {
        "question": "¿Qué trae la Fall '26 Edition de Shopify para los agentes de IA?",
        "answer": "La documentación para desarrolladores de Shopify describe agentes que buscan en Shopify Catalog, arman carritos y crean checkouts en tu tienda, y herramientas en cada tienda con Liquid para que un agente busque, actualice el carrito, vaya al checkout y responda sobre tus políticas. El comprador confirma antes de la compra y tú sigues siendo el vendedor registrado."
      },
      {
        "question": "¿Tengo que instalar algo para que los agentes de IA compren en mi tienda Shopify?",
        "answer": "Para las herramientas de la tienda, no. Shopify dice que las herramientas WebMCP ya funcionan en cada tienda con Liquid sin instalar ni configurar nada. Lo que sí conviene es dejar claros tus datos de producto y tus políticas, porque eso es lo que leen los agentes."
      },
      {
        "question": "¿De dónde sacan los agentes las respuestas sobre mis devoluciones y envíos?",
        "answer": "De las políticas y la base de conocimiento de tu tienda, según la documentación de Ask de Shopify. Escríbelas con números concretos, como los días para devolver y la lista de países de envío, para que un agente las repita bien."
      },
      {
        "question": "¿Debo editar el archivo agents.md que crea Shopify?",
        "answer": "Normalmente no. Shopify lo administra para cada tienda y lo mantiene al día con tu configuración. Una plantilla agents.md propia también reemplaza tu llms.txt y te toca mantenerla."
      }
    ],
    "keyTakeaways": []
  },
  {
    "id": 57,
    "slug": "shopify-fall-26-ai-agents-setup",
    "title": "Shopify's Fall '26 Edition opens your store to AI agents. What to set up first",
    "excerpt": "AI agents can now search your Shopify catalog, fill a cart on your storefront and take the shopper to your checkout. They work from your product data and your policies, so those are what to fix. Five things to check this week.",
    "author": {
      "name": "José Antonio Mijares",
      "role": "Founder & AI Strategist",
      "avatar": "/images/team/jose-mijares.png",
      "twitter": "@joseamijares"
    },
    "category": "CRO",
    "tags": [
      "Shopify",
      "Shopify Editions",
      "AI Agents",
      "Agentic Commerce",
      "Checkout"
    ],
    "publishedAt": "2026-11-03",
    "modifiedAt": "2026-11-03",
    "readingTime": "6 min read",
    "featuredImage": "/images/blog/shopify-fall-26-ai-agents-setup-cover.webp",
    "featuredImageSize": {
      "width": 1600,
      "height": 1000
    },
    "figures": [
      {
        "src": "/images/blog/shopify-fall-26-ai-agents-setup-explainer-en.webp",
        "alt": "Four cards in a row under the headline \"Agents read your store. Write it as facts.\": 01 CATALOG, products and variants, name every option plainly; 02 POLICIES, returns, shipping, payment, days, countries, methods; 03 CART, your theme's own cart, test a custom cart once; 04 CHECKOUT, your checkout, your order, the shopper confirms first.",
        "caption": "What Shopify opens to AI agents in the Fall '26 Edition, and what each part reads from your store. Source: Shopify developer docs, November 2026.",
        "width": 1600,
        "height": 900
      }
    ],
    "seoKeywords": [
      "Shopify Fall 26 Edition",
      "Shopify AI agents",
      "Shopify agentic commerce setup",
      "Shopify WebMCP",
      "sell on ChatGPT Shopify"
    ],
    "faqSchema": [
      {
        "question": "What is in Shopify's Fall '26 Edition for AI agents?",
        "answer": "Shopify's developer docs describe agents that search Shopify Catalog, build carts and create checkouts at your store, and browser tools on every Liquid storefront that let an agent search, update the cart, go to checkout and answer policy questions. The shopper confirms before a purchase, and you stay the merchant of record."
      },
      {
        "question": "Do I need to install anything for AI agents to shop my Shopify store?",
        "answer": "For the storefront tools, no. Shopify says the WebMCP tools are live on every Liquid storefront with nothing to install or configure. What you should do is make your product data and policies clear, because that is what agents read."
      },
      {
        "question": "Where do agents get answers about my return and shipping policies?",
        "answer": "From your store's policies and knowledge base, according to Shopify's Ask documentation. Write them with specific numbers, such as a return window in days and a list of shipping countries, so an agent can repeat them accurately."
      },
      {
        "question": "Should I edit the agents.md file Shopify creates?",
        "answer": "Usually not. Shopify manages it for every store and keeps it in sync with your commerce setup. A custom agents.md template also replaces your llms.txt, and you take on keeping it current."
      }
    ],
    "keyTakeaways": []
  },
  {
    "id": 54,
    "slug": "es-google-ai-mode-official-sites-test",
    "title": "Google probará una sección de \"sitios oficiales\" en sus respuestas de IA. ¿Tu página es la que elegiría?",
    "excerpt": "El 15 de octubre de 2026, Google dijo que probará una sección al inicio de algunas respuestas de AI Mode y AI Overviews que enlaza uno o dos sitios oficiales. Qué es la prueba, qué no ha dicho Google y cinco ajustes para la página que quieres que elija.",
    "author": {
      "name": "José Antonio Mijares",
      "role": "Founder & AI Strategist",
      "avatar": "/images/team/jose-mijares.png",
      "twitter": "@joseamijares"
    },
    "category": "SEO",
    "tags": [
      "AI Mode",
      "AI Overviews",
      "Google Search",
      "GEO",
      "Sitios oficiales"
    ],
    "publishedAt": "2026-10-27",
    "modifiedAt": "2026-10-27",
    "readingTime": "5 min de lectura",
    "featuredImage": "/images/blog/google-ai-mode-official-sites-test-cover.webp",
    "featuredImageSize": {
      "width": 1600,
      "height": 1000
    },
    "figures": [
      {
        "src": "/images/blog/google-ai-mode-official-sites-test-explainer-es.webp",
        "alt": "Cinco tarjetas con las etiquetas UNA URL POR TAREA, LA RESPUESTA EN EL TEXTO, LOS MISMOS DATOS, DI QUIÉN ES EL DUEÑO y DEJA QUE GOOGLE LA LEA, cada una con una línea de qué revisar.",
        "caption": "Cinco revisiones para la página que quieres que Google trate como oficial. Ninguna garantiza la sección; todas ayudan al lector que llega.",
        "width": 1600,
        "height": 900
      }
    ],
    "seoKeywords": [
      "Google AI Mode sitios oficiales",
      "AI Overviews sitio oficial",
      "cambios de enlaces en AI Mode octubre 2026",
      "sitio oficial en respuestas de IA",
      "GEO páginas de servicio"
    ],
    "faqSchema": [
      {
        "question": "¿Qué es la prueba de sitios oficiales de Google?",
        "answer": "Una sección que Google dijo el 15 de octubre de 2026 que probará al inicio de algunas respuestas de AI Mode y AI Overviews. Cuando solo hay uno o dos lugares oficiales en la web para completar una tarea o encontrar un dato exacto, los enlaza en una sección propia, con contexto de por qué sirve cada enlace."
      },
      {
        "question": "¿Cómo meto mi sitio en la sección de sitios oficiales?",
        "answer": "Google no ha publicado criterios, lista de países ni fecha de lanzamiento. Haz que la página dueña de cada tarea sea fácil de identificar: una URL por tarea, la respuesta en texto, los mismos datos en tus perfiles, schema de Organization y nada que bloquee a Googlebot o los fragmentos."
      },
      {
        "question": "¿Esto reemplaza rankear en Google?",
        "answer": "No. El resto de la respuesta y los resultados de abajo siguen saliendo del índice de Google. La prueba solo agrega una sección para un tipo muy específico de pregunta de tarea."
      },
      {
        "question": "¿Qué páginas arreglo primero?",
        "answer": "Reembolsos y devoluciones, reservas, garantías, precios y horarios, y soporte. Son las preguntas que solo tu propio sitio puede responder."
      }
    ],
    "keyTakeaways": []
  },
  {
    "id": 56,
    "slug": "es-shopify-payments-oxxo-mexico",
    "title": "Shopify Payments ya acepta pago en OXXO en México. Cómo activarlo y manejar los pedidos",
    "excerpt": "Las tiendas en México ya pueden ofrecer pago en efectivo en OXXO con Shopify Payments, sin una app de terceros. Quién califica, los límites, qué pasa con el pedido mientras el cliente tiene 5 días para pagar y cómo hacer reembolsos.",
    "author": {
      "name": "José Antonio Mijares",
      "role": "Founder & AI Strategist",
      "avatar": "/images/team/jose-mijares.png",
      "twitter": "@joseamijares"
    },
    "category": "CRO",
    "tags": [
      "Shopify",
      "Shopify Payments",
      "OXXO",
      "México",
      "Checkout"
    ],
    "publishedAt": "2026-10-27",
    "modifiedAt": "2026-10-27",
    "readingTime": "5 min de lectura",
    "featuredImage": "/images/blog/shopify-payments-oxxo-mexico-cover.webp",
    "featuredImageSize": {
      "width": 1600,
      "height": 1000
    },
    "figures": [
      {
        "src": "/images/blog/shopify-payments-oxxo-mexico-explainer-es.webp",
        "alt": "Cuatro tarjetas en fila con las etiquetas 01 CHECKOUT, 02 CÓDIGO DE BARRAS, 03 EFECTIVO EN OXXO y 04 ENVÍO: el cliente elige OXXO y paga en pesos, de 10 a 10,000 en OXXO; el código vale por 5 días mientras el pedido aparece como pendiente de pago; el pago se confirma en hasta 3 días hábiles y el pedido sigue pendiente mientras; envía solo cuando esté pagado y reembolsa con crédito en tienda o transferencia.",
        "caption": "Un pedido con OXXO en Shopify Payments, del checkout al envío. Fuente: Centro de ayuda de Shopify, octubre de 2026.",
        "width": 1600,
        "height": 900
      }
    ],
    "seoKeywords": [
      "Shopify Payments OXXO",
      "pago en OXXO Shopify",
      "Shopify pago en efectivo México",
      "activar OXXO en Shopify",
      "pedido pendiente de pago OXXO Shopify"
    ],
    "faqSchema": [
      {
        "question": "¿Shopify Payments acepta OXXO?",
        "answer": "Sí, para tiendas en México con una cuenta de Shopify Payments México, la verificación de identidad completa y una categoría de negocio elegible. El cliente paga en efectivo en una tienda OXXO, en pesos mexicanos, y el monto que paga en OXXO debe ser de 10 a 10,000 MXN."
      },
      {
        "question": "¿Cuánto tiempo tiene el cliente para pagar en OXXO?",
        "answer": "El código de barras vale por 5 días desde que se hace el pedido. Después, el pedido sigue en Pago pendiente hasta 3 días hábiles más, contados con el calendario mexicano, para que un pago hecho cerca del límite todavía se confirme."
      },
      {
        "question": "¿Cómo reembolso un pedido de OXXO en Shopify?",
        "answer": "Shopify Payments no puede devolver un pago de OXXO por el mismo medio. Emite crédito en tienda como método de reembolso, o haz una transferencia bancaria fuera de Shopify y después registra el reembolso en el pedido, porque Shopify no registra la transferencia por sí solo."
      },
      {
        "question": "¿OXXO funciona con Shopify POS o suscripciones?",
        "answer": "No. Shopify indica que OXXO no está disponible para Shopify POS, pagos en persona, suscripciones ni Shop Pay Installments."
      }
    ],
    "keyTakeaways": []
  },
  {
    "id": 53,
    "slug": "google-ai-mode-official-sites-test",
    "title": "Google will test an \"official sites\" box in AI answers. Is your page the one it would pick?",
    "excerpt": "On October 15, 2026, Google said it will test a section at the top of some AI Mode and AI Overviews answers that links one or two official sites. What the test is, what Google hasn't said, and five fixes for the page you want it to pick.",
    "author": {
      "name": "José Antonio Mijares",
      "role": "Founder & AI Strategist",
      "avatar": "/images/team/jose-mijares.png",
      "twitter": "@joseamijares"
    },
    "category": "SEO",
    "tags": [
      "AI Mode",
      "AI Overviews",
      "Google Search",
      "GEO",
      "Official sites"
    ],
    "publishedAt": "2026-10-27",
    "modifiedAt": "2026-10-27",
    "readingTime": "5 min read",
    "featuredImage": "/images/blog/google-ai-mode-official-sites-test-cover.webp",
    "featuredImageSize": {
      "width": 1600,
      "height": 1000
    },
    "figures": [
      {
        "src": "/images/blog/google-ai-mode-official-sites-test-explainer-en.webp",
        "alt": "Five cards labelled ONE URL PER TASK, ANSWER IN THE TEXT, SAME FACTS EVERYWHERE, NAME THE OWNER and LET GOOGLE READ IT, each with one line on what to check.",
        "caption": "Five checks for the page you want Google to treat as official. None of them guarantee the box; all of them help the reader who lands.",
        "width": 1600,
        "height": 900
      }
    ],
    "seoKeywords": [
      "Google AI Mode official sites",
      "AI Overviews official website",
      "Google AI Mode links update October 2026",
      "official site in AI answers",
      "GEO service pages"
    ],
    "faqSchema": [
      {
        "question": "What is Google's official-sites test?",
        "answer": "A section Google said on October 15, 2026 it will test at the top of some AI Mode and AI Overviews answers. When there are only one or two official places on the web to complete a task or get exact information, it links them in a dedicated section, with context about why each link is useful."
      },
      {
        "question": "How do I get my site into the official-sites section?",
        "answer": "Google hasn't published criteria, a country list or a launch date. Make the page that owns each task easy to identify: one URL per task, the answer in plain text, the same facts across your profiles, Organization schema, and nothing blocking Googlebot or snippets."
      },
      {
        "question": "Does this replace ranking in Google?",
        "answer": "No. The rest of the answer and the results below it still come from Google's index. The test only adds a section for a narrow kind of task question."
      },
      {
        "question": "Which pages should I fix first?",
        "answer": "Refunds and returns, bookings, warranty, prices and hours, and support. They're the questions only your own site can answer."
      }
    ],
    "keyTakeaways": []
  },
  {
    "id": 55,
    "slug": "shopify-payments-oxxo-mexico",
    "title": "Shopify Payments now takes OXXO in Mexico. How to turn it on and run the orders",
    "excerpt": "Stores in Mexico can now offer cash payment at OXXO through Shopify Payments, without a third-party app. Who qualifies, the limits, what happens to an order while the customer has 5 days to pay, and how to handle refunds.",
    "author": {
      "name": "José Antonio Mijares",
      "role": "Founder & AI Strategist",
      "avatar": "/images/team/jose-mijares.png",
      "twitter": "@joseamijares"
    },
    "category": "CRO",
    "tags": [
      "Shopify",
      "Shopify Payments",
      "OXXO",
      "Mexico",
      "Checkout"
    ],
    "publishedAt": "2026-10-27",
    "modifiedAt": "2026-10-27",
    "readingTime": "5 min read",
    "featuredImage": "/images/blog/shopify-payments-oxxo-mexico-cover.webp",
    "featuredImageSize": {
      "width": 1600,
      "height": 1000
    },
    "figures": [
      {
        "src": "/images/blog/shopify-payments-oxxo-mexico-explainer-en.webp",
        "alt": "Four cards in a row labelled 01 CHECKOUT, 02 BARCODE, 03 CASH AT OXXO and 04 SHIP: the customer picks OXXO and pays in pesos, 10 to 10,000 at OXXO; the barcode is valid for 5 days while the order shows Payment pending; the payment is confirmed within 3 business days, and the order stays pending until then; ship only when paid, and refund with store credit or a transfer.",
        "caption": "An OXXO order on Shopify Payments, from checkout to shipping. Source: Shopify Help Center, October 2026.",
        "width": 1600,
        "height": 900
      }
    ],
    "seoKeywords": [
      "Shopify Payments OXXO",
      "OXXO Shopify Mexico",
      "pay at OXXO Shopify checkout",
      "Shopify cash payment Mexico",
      "Shopify OXXO pending payment"
    ],
    "faqSchema": [
      {
        "question": "Does Shopify Payments accept OXXO?",
        "answer": "Yes, for stores in Mexico with a Shopify Payments Mexico account, identity verification complete and an eligible business category. The customer pays in cash at an OXXO store, in Mexican pesos, and the amount paid at OXXO must be from 10 to 10,000 MXN."
      },
      {
        "question": "How long does a customer have to pay at OXXO?",
        "answer": "The barcode is valid for 5 days after the order is placed. The order then stays Payment pending for up to 3 more business days, counted on the Mexican calendar, so a payment made near the deadline can still be confirmed."
      },
      {
        "question": "How do I refund an OXXO order on Shopify?",
        "answer": "Shopify Payments can't refund an OXXO payment to the original method. Issue store credit as the refund method, or send a bank transfer outside Shopify and then record the refund on the order, because Shopify won't record the transfer on its own."
      },
      {
        "question": "Does OXXO work with Shopify POS or subscriptions?",
        "answer": "No. Shopify lists OXXO as unavailable for Shopify POS, in-person payments, subscriptions and Shop Pay Installments."
      }
    ],
    "keyTakeaways": []
  },
  {
    "id": 51,
    "slug": "claude-code-projects-ai-agency-workflow",
    "title": "What are Claude Code Projects? One conversation that runs your work in parallel.",
    "excerpt": "Anthropic's Claude Code Projects turn one conversation into a coordinator that starts parallel threads, keeps shared memory, and tells you what needs you. What it is, when to use it, and how to set one up.",
    "author": {
      "name": "José Antonio Mijares",
      "role": "Founder & AI Strategist",
      "avatar": "/images/team/jose-mijares.png",
      "twitter": "@joseamijares"
    },
    "category": "AI",
    "tags": [
      "Claude Code",
      "AI agents",
      "Anthropic",
      "Parallel agents",
      "AI implementation"
    ],
    "publishedAt": "2026-10-25",
    "modifiedAt": "2026-10-25",
    "readingTime": "7 min read",
    "featuredImage": "/images/blog/claude-code-projects-ai-agency-workflow-cover.webp",
    "featuredImageSize": {
      "width": 1600,
      "height": 1000
    },
    "figures": [
      {
        "src": "/images/blog/claude-code-projects-ai-agency-workflow-explainer-en.webp",
        "alt": "Four cards explaining how a Claude Code project is organized: 01 Conversation, Claude coordinates and you send work there; 02 Threads, one task each with its own branch and pull request; 03 Memory, context set once that every thread reads; 04 Overview, shows what needs you, grouped as ready, waiting and working. Footnote: beta on Pro and Max since September 17, 2026.",
        "caption": "A project is one coordinating conversation plus the threads it starts. You brief it once and read the results in Overview.",
        "width": 1600,
        "height": 900
      }
    ],
    "seoKeywords": [
      "Claude Code Projects",
      "Claude Code projects beta",
      "Claude Code parallel threads",
      "Claude Code coordinator",
      "Anthropic Claude Code"
    ],
    "faqSchema": [
      {
        "question": "What are Claude Code Projects?",
        "answer": "A beta feature from Anthropic, released September 17, 2026. A project is one ongoing conversation where Claude coordinates related work: it starts a thread per task, each thread is a Claude Code session on its own branch, and it keeps shared instructions and memory across all of them."
      },
      {
        "question": "Who can use Claude Code Projects?",
        "answer": "Pro and Max subscribers, in a gradual rollout that started with people who use Claude Code cloud sessions. Team and Enterprise plans are not included in the beta yet. If you don't see it, Anthropic has a waitlist."
      },
      {
        "question": "Is this the same as Projects in Claude chat?",
        "answer": "No. The earlier Projects group conversations and reference files, with no threads and no coordinator. Those keep working as they do until the new experience reaches chat and Cowork."
      },
      {
        "question": "Do threads run on my computer?",
        "answer": "Usually in the cloud. When a task needs a local database, an emulator or an API behind your VPN, you can ask Claude to run that one thread on your computer through Remote Control. It runs only while that computer is awake."
      },
      {
        "question": "How much does it cost?",
        "answer": "Nothing beyond your Pro or Max plan, but it uses the plan faster than a single session. Pick a smaller model or lower effort for routine threads, and run fewer threads at once, to keep it down. --- Jamak sets up AI workflows that run in production, starting with our own. The adoption work is [AI Implementation](/services/ai-implementation). Agents built to production standard are [AI Agents](/services/ai-agents). Talk to us. No rate card."
      }
    ],
    "keyTakeaways": []
  },
  {
    "id": 52,
    "slug": "es-claude-code-projects-ai-agency-workflow",
    "title": "¿Qué son los Projects de Claude Code? Una conversación que corre tu trabajo en paralelo.",
    "excerpt": "Los Projects de Claude Code convierten una conversación en un coordinador que abre hilos en paralelo, guarda memoria compartida y te dice qué te necesita. Qué son, cuándo usarlos y cómo arrancar uno.",
    "author": {
      "name": "José Antonio Mijares",
      "role": "Founder & AI Strategist",
      "avatar": "/images/team/jose-mijares.png",
      "twitter": "@joseamijares"
    },
    "category": "AI",
    "tags": [
      "Claude Code",
      "Agentes de IA",
      "Anthropic",
      "Agentes en paralelo",
      "Implementación de IA"
    ],
    "publishedAt": "2026-10-25",
    "modifiedAt": "2026-10-25",
    "readingTime": "7 min de lectura",
    "featuredImage": "/images/blog/claude-code-projects-ai-agency-workflow-cover.webp",
    "featuredImageSize": {
      "width": 1600,
      "height": 1000
    },
    "figures": [
      {
        "src": "/images/blog/claude-code-projects-ai-agency-workflow-explainer-es.webp",
        "alt": "Cuatro tarjetas que explican cómo se organiza un proyecto de Claude Code: 01 Conversación, Claude coordina y ahí mandas el trabajo; 02 Hilos, una tarea cada uno con su rama y su PR; 03 Memoria, el contexto se define una vez y cada hilo lo lee; 04 Overview, muestra qué te necesita, agrupado como listo, en espera y en curso. Nota: beta en Pro y Max desde el 17 de septiembre de 2026.",
        "caption": "Un proyecto es una conversación que coordina más los hilos que abre. Lo instruyes una vez y lees los resultados en Overview.",
        "width": 1600,
        "height": 900
      }
    ],
    "seoKeywords": [
      "Claude Code Projects",
      "proyectos de Claude Code",
      "Claude Code hilos en paralelo",
      "coordinador de Claude Code",
      "Anthropic Claude Code"
    ],
    "faqSchema": [
      {
        "question": "¿Qué son los Projects de Claude Code?",
        "answer": "Una función en beta de Anthropic, lanzada el 17 de septiembre de 2026. Un proyecto es una conversación continua donde Claude coordina trabajo relacionado: abre un hilo por tarea, cada hilo es una sesión de Claude Code en su propia rama, y mantiene instrucciones y memoria compartidas entre todos."
      },
      {
        "question": "¿Quién puede usar Claude Code Projects?",
        "answer": "Suscriptores de Pro y Max, en una liberación gradual que empezó con quienes usan sesiones de Claude Code en la nube. Los planes Team y Enterprise todavía no están en la beta. Si no lo ves, Anthropic tiene lista de espera."
      },
      {
        "question": "¿Es lo mismo que los Projects del chat de Claude?",
        "answer": "No. Los Projects anteriores agrupan conversaciones y archivos de referencia, sin hilos y sin coordinador. Siguen funcionando igual hasta que la nueva experiencia llegue al chat y a Cowork."
      },
      {
        "question": "¿Los hilos corren en mi computadora?",
        "answer": "Normalmente en la nube. Cuando una tarea necesita una base de datos local, un emulador o una API detrás de tu VPN, puedes pedirle a Claude que ese hilo corra en tu computadora con Remote Control. Solo corre mientras esa computadora está despierta."
      },
      {
        "question": "¿Cuánto cuesta?",
        "answer": "Nada aparte de tu plan Pro o Max, pero lo gasta más rápido que una sola sesión. Usa un modelo más chico o menos esfuerzo para los hilos rutinarios, y corre menos hilos a la vez, para mantenerlo bajo control. --- Jamak arma flujos de IA que corren en producción, empezando por los nuestros. El trabajo de adopción es [Implementación de IA](/es/services/ai-implementation). Los agentes hechos para producción son [Agentes de IA](/es/services/ai-agents). Háblanos. Sin tarifa publicada."
      }
    ],
    "keyTakeaways": []
  },
  {
    "id": 50,
    "slug": "es-inflated-backlink-count-seo-checker-pages",
    "title": "Por qué tu conteo de backlinks está inflado (y qué hacer al respecto)",
    "excerpt": "La mayoría de los \"backlinks\" nuevos de un sitio pequeño vienen de páginas de checadores SEO que imprimen una página por cada dominio que ven. Google los descuenta. Así los detectas y esto es lo que sí debes contar.",
    "author": {
      "name": "José Antonio Mijares",
      "role": "Founder & AI Strategist",
      "avatar": "/images/team/jose-mijares.png",
      "twitter": "@joseamijares"
    },
    "category": "SEO",
    "tags": [
      "SEO",
      "Backlinks",
      "Link building",
      "Disavow",
      "Search Console"
    ],
    "publishedAt": "2026-10-24",
    "modifiedAt": "2026-10-24",
    "readingTime": "6 min de lectura",
    "featuredImage": "/images/blog/inflated-backlink-count-seo-checker-pages-cover.webp",
    "featuredImageSize": {
      "width": 1600,
      "height": 1000
    },
    "figures": [
      {
        "src": "/images/blog/inflated-backlink-count-seo-checker-pages-explainer-es.webp",
        "alt": "Gráfica de barras de los backlinks de jamaklab.com en octubre de 2026: 1,765 registrados desde 1,720 dominios, 1,431 con spam score de 50 o más (81%) y 2 con spam score menor a 20.",
        "caption": "De 1,765 backlinks registrados, 2 tienen spam score menor a 20. Esos son los que vale la pena contar.",
        "width": 1600,
        "height": 900
      }
    ],
    "seoKeywords": [
      "backlinks spam",
      "conteo de backlinks inflado",
      "debo desautorizar backlinks spam",
      "dominios spam de herramientas seo",
      "dominios de referencia reales"
    ],
    "faqSchema": [
      {
        "question": "¿Debo desautorizar los backlinks spam de sitios de checadores SEO?",
        "answer": "No, a menos que Search Console muestre una acción manual. Google ya descuenta los enlaces creados por programas automáticos, y su herramienta de desautorización está pensada para enlaces que causaron o probablemente causen una acción manual."
      },
      {
        "question": "¿Por qué mi conteo de backlinks subió de un día para otro?",
        "answer": "Casi siempre porque una red de checadores SEO generó una página para tu dominio. Busca grupos de dominios .store, .site, .space y .online con texto ancla de plantilla."
      },
      {
        "question": "¿Alguien puede bajar mi posicionamiento apuntando enlaces spam a mi sitio?",
        "answer": "Google trata los enlaces creados por programas automáticos como spam y trabaja para descontarlos, no para premiar ni castigar al sitio al que apuntan. Si algún día recibes una acción manual por enlaces no naturales, el archivo disavow es la herramienta."
      },
      {
        "question": "¿Cuántos backlinks reales necesita el sitio de un negocio pequeño?",
        "answer": "No hay un número fijo. Unos cuantos enlaces relevantes desde páginas que la gente sí lee valen más que cualquier total en una herramienta de backlinks."
      },
      {
        "question": "¿Los backlinks spam afectan las respuestas de IA como ChatGPT o Perplexity?",
        "answer": "No hay evidencia pública de que ayuden. Los motores de IA citan páginas que pueden leer y en las que confían. [Cómo checar si ChatGPT cita tu marca](/es/blog/es-how-to-check-if-chatgpt-cites-your-brand) es el método que usamos. --- Jamak hace SEO y GEO para tiendas y SaaS. El trabajo de posicionamiento es [SEO](/es/services/seo). El trabajo de citación es [GEO](/es/services/geo). Háblanos. Sin tarifa publicada. Sin resultados inventados."
      }
    ],
    "keyTakeaways": []
  },
  {
    "id": 49,
    "slug": "inflated-backlink-count-seo-checker-pages",
    "title": "Why your backlink count is inflated (and what to do about it)",
    "excerpt": "Most new \"backlinks\" on a small site come from SEO-checker pages that print a page for every domain they see. Google discounts them. Here is how to spot them and what to count instead.",
    "author": {
      "name": "José Antonio Mijares",
      "role": "Founder & AI Strategist",
      "avatar": "/images/team/jose-mijares.png",
      "twitter": "@joseamijares"
    },
    "category": "SEO",
    "tags": [
      "SEO",
      "Backlinks",
      "Link building",
      "Disavow",
      "Search Console"
    ],
    "publishedAt": "2026-10-24",
    "modifiedAt": "2026-10-24",
    "readingTime": "6 min read",
    "featuredImage": "/images/blog/inflated-backlink-count-seo-checker-pages-cover.webp",
    "featuredImageSize": {
      "width": 1600,
      "height": 1000
    },
    "figures": [
      {
        "src": "/images/blog/inflated-backlink-count-seo-checker-pages-explainer-en.webp",
        "alt": "Bar chart of jamaklab.com backlinks in October 2026: 1,765 on record from 1,720 domains, 1,431 with a spam score of 50 or more (81%), and 2 with a spam score under 20.",
        "caption": "Of 1,765 recorded backlinks, 2 scored under 20 on spam score. Those are the ones worth counting.",
        "width": 1600,
        "height": 900
      }
    ],
    "seoKeywords": [
      "inflated backlink count",
      "spam backlinks from seo tools",
      "should i disavow spam backlinks",
      "backlink checker spam domains",
      "real referring domains"
    ],
    "faqSchema": [
      {
        "question": "Should I disavow spam backlinks from SEO-checker sites?",
        "answer": "Not unless Search Console shows a manual action. Google already discounts links made by automated programs, and its disavow tool is meant for links that caused or are likely to cause a manual action."
      },
      {
        "question": "Why did my backlink count jump overnight?",
        "answer": "Usually because a network of SEO-checker sites generated a page for your domain. Look for clusters of .store, .site, .space and .online domains with templated anchor text."
      },
      {
        "question": "Can someone hurt my rankings by pointing spam links at my site?",
        "answer": "Google treats links made by automated programs as spam and works to discount them rather than reward or punish the site they point at. If you ever receive a manual action for unnatural links, a disavow file is the tool for it."
      },
      {
        "question": "How many real backlinks does a small business site need?",
        "answer": "There is no fixed number. A handful of relevant links from pages people actually read is worth more than any total in a backlink tool."
      },
      {
        "question": "Do spam backlinks affect AI answers like ChatGPT or Perplexity?",
        "answer": "There is no public evidence that they help. AI engines cite pages they can read and trust. [How to check if ChatGPT cites your brand](/blog/how-to-check-if-chatgpt-cites-your-brand) is the method we use. --- Jamak does SEO and GEO for stores and SaaS. The ranking work is [SEO](/services/seo). The citation work is [GEO](/services/geo). Talk to us. No rate card. No fake results."
      }
    ],
    "keyTakeaways": []
  },
  {
    "id": 39,
    "slug": "ai-agent-production-harness",
    "title": "What makes an AI agent production-ready? The harness, not the model.",
    "excerpt": "A demo agent takes a weekend. A production agent takes evals, tools, memory, permissions, and logs. Here is the checklist.",
    "author": {
      "name": "José Antonio Mijares",
      "role": "Founder & AI Strategist",
      "avatar": "/images/team/jose-mijares.png",
      "twitter": "@joseamijares"
    },
    "category": "AI",
    "tags": [
      "AI agents",
      "Agent harness",
      "Evals",
      "LLM",
      "Production AI"
    ],
    "publishedAt": "2026-10-02",
    "modifiedAt": "2026-10-02",
    "readingTime": "6 min read",
    "featuredImage": "/images/blog/ai-agent-production-harness-cover.webp",
    "featuredImageSize": {
      "width": 1600,
      "height": 1000
    },
    "figures": [
      {
        "src": "/images/blog/ai-agent-production-harness-explainer-en.webp",
        "alt": "Five cards naming the parts of an AI agent harness: evals (real tasks with known answers, run on every change), tools (one job each, errors the model can read), memory (kept on purpose), permissions (runs alone, needs approval, or never runs) and observability (every run logged).",
        "caption": "A production agent is the model plus five parts around it. Without evals, every change is a guess.",
        "width": 1600,
        "height": 900
      }
    ],
    "seoKeywords": [
      "production-ready AI agent",
      "AI agent harness",
      "AI agent evals",
      "build AI agents",
      "agent permissions"
    ],
    "faqSchema": [
      {
        "question": "What is an AI agent harness?",
        "answer": "Everything around the model that makes the agent dependable: evals, tools, memory, permissions, and observability. The model reasons. The harness decides whether that reasoning is safe to act on."
      },
      {
        "question": "Which model should I use for an agent?",
        "answer": "Start with the best one available, get the evals passing, then try cheaper ones against the same evals. The evals tell you when a cheaper model is good enough. Opinions do not."
      },
      {
        "question": "How many eval cases do I need?",
        "answer": "Enough real cases to cover the common path and the failures you already know about. Twenty real cases from last month is a good start. Add every new failure as a case."
      },
      {
        "question": "When should an agent act without approval?",
        "answer": "When the action is reversible, low cost, and the evals show it gets it right. Refunds, deletes, and customer messages start behind approval."
      },
      {
        "question": "Is an agent the same as AI implementation?",
        "answer": "No. Implementation is deciding where AI belongs in a business and wiring it into the stack. Building an agent is one way to do that. [How AI pilots reach production](/blog/ai-pilot-to-production) covers the first part. --- Jamak builds production agents with the harness included. We run agents in our own products first. The agent work is [AI Agents](/services/ai-agents). The adoption work is [AI Implementation](/services/ai-implementation). Talk to us. No rate card."
      }
    ],
    "keyTakeaways": []
  },
  {
    "id": 41,
    "slug": "ai-pilot-to-production",
    "title": "Why AI pilots stall before production, and how to pick one that ships",
    "excerpt": "Most pilots fail at the choice, not the build. Pick one workflow, one owner, one number. Wire it into the stack you already have.",
    "author": {
      "name": "José Antonio Mijares",
      "role": "Founder & AI Strategist",
      "avatar": "/images/team/jose-mijares.png",
      "twitter": "@joseamijares"
    },
    "category": "AI",
    "tags": [
      "AI implementation",
      "AI adoption",
      "AI pilot",
      "LLM integration",
      "AI strategy"
    ],
    "publishedAt": "2026-10-02",
    "modifiedAt": "2026-10-02",
    "readingTime": "6 min read",
    "featuredImage": "/images/blog/ai-pilot-to-production-cover.webp",
    "featuredImageSize": {
      "width": 1600,
      "height": 1000
    },
    "figures": [
      {
        "src": "/images/blog/ai-pilot-to-production-explainer-en.webp",
        "alt": "Five checks for choosing an AI pilot: one workflow a person does today, one owner on that team, one number that already exists, data from the real system rather than an export, and a safe failure where a person reviews the output first.",
        "caption": "Run every pilot candidate through these five checks and drop any that fails one.",
        "width": 1600,
        "height": 900
      }
    ],
    "seoKeywords": [
      "AI pilot to production",
      "AI implementation",
      "AI adoption strategy",
      "why AI pilots fail",
      "AI integration"
    ],
    "faqSchema": [
      {
        "question": "How long should an AI pilot take?",
        "answer": "One workflow, built into the existing stack, is usually weeks, not months. If the plan says a year, the scope is a program, not a pilot."
      },
      {
        "question": "What is a good first AI use case?",
        "answer": "Repetitive work a person already does with text or documents: drafting replies, classifying requests, extracting fields, summarizing calls. It has an owner, a number, and a safe review step."
      },
      {
        "question": "Do we need a data team first?",
        "answer": "Not for most first pilots. You need access to the system where the work happens and a person who knows what a good answer looks like."
      },
      {
        "question": "Build or buy?",
        "answer": "Buy when an off-the-shelf tool already does the exact task inside a system you use. Build when the task depends on your data, your rules, and your stack."
      },
      {
        "question": "When do agents come in?",
        "answer": "When the task needs judgment across several steps and tools. Many first pilots are not agents and should not be. [What makes an agent production-ready](/blog/ai-agent-production-harness) covers that side. --- Jamak implements AI inside the stack you already run, and hands it to your team. We ship AI products of our own, so this is implementation, not a deck. The adoption work is [AI Implementation](/services/ai-implementation). The agent work is [AI Agents](/services/ai-agents). Talk to us. No rate card."
      }
    ],
    "keyTakeaways": []
  },
  {
    "id": 40,
    "slug": "es-ai-agent-production-harness",
    "title": "¿Qué hace que un agente de IA esté listo para producción? El harness, no el modelo.",
    "excerpt": "Un agente de demo sale en un fin de semana. Uno de producción necesita evals, herramientas, memoria, permisos y logs. Aquí está la lista.",
    "author": {
      "name": "José Antonio Mijares",
      "role": "Founder & AI Strategist",
      "avatar": "/images/team/jose-mijares.png",
      "twitter": "@joseamijares"
    },
    "category": "AI",
    "tags": [
      "Agentes de IA",
      "Harness de agentes",
      "Evals",
      "LLM",
      "IA en producción"
    ],
    "publishedAt": "2026-10-02",
    "modifiedAt": "2026-10-02",
    "readingTime": "6 min de lectura",
    "featuredImage": "/images/blog/ai-agent-production-harness-cover.webp",
    "featuredImageSize": {
      "width": 1600,
      "height": 1000
    },
    "figures": [
      {
        "src": "/images/blog/ai-agent-production-harness-explainer-es.webp",
        "alt": "Cinco tarjetas con las partes del harness de un agente de IA: evals (tareas reales con respuestas conocidas, en cada cambio), herramientas (una tarea cada una, errores que el modelo entiende), memoria (se guarda a propósito), permisos (solo, con aprobación o nunca) y observabilidad (cada ejecución registrada).",
        "caption": "Un agente en producción es el modelo más cinco partes a su alrededor. Sin evals, cada cambio es una apuesta.",
        "width": 1600,
        "height": 900
      }
    ],
    "seoKeywords": [
      "agente de IA listo para producción",
      "harness de agentes de IA",
      "evals para agentes de IA",
      "desarrollo de agentes de IA",
      "permisos de agentes"
    ],
    "faqSchema": [
      {
        "question": "¿Qué es el harness de un agente de IA?",
        "answer": "Todo lo que rodea al modelo y vuelve confiable al agente: evals, herramientas, memoria, permisos y observabilidad. El modelo razona. El harness decide si es seguro actuar con ese razonamiento."
      },
      {
        "question": "¿Qué modelo debo usar para un agente?",
        "answer": "Empieza con el mejor disponible, haz que pasen las evals y luego prueba modelos más baratos contra las mismas evals. Las evals te dicen cuándo un modelo más barato es suficiente. Las opiniones no."
      },
      {
        "question": "¿Cuántos casos de eval necesito?",
        "answer": "Los suficientes casos reales para cubrir el camino común y las fallas que ya conoces. Veinte casos reales del mes pasado son un buen inicio. Cada falla nueva se vuelve un caso."
      },
      {
        "question": "¿Cuándo debe actuar un agente sin aprobación?",
        "answer": "Cuando la acción es reversible, de bajo costo y las evals muestran que la hace bien. Reembolsos, borrados y mensajes a clientes empiezan detrás de una aprobación."
      },
      {
        "question": "¿Un agente es lo mismo que implementar IA?",
        "answer": "No. Implementar es decidir dónde tiene sentido la IA en el negocio y conectarla al stack. Construir un agente es una forma de hacerlo. [Cómo llega un piloto de IA a producción](/es/blog/es-ai-pilot-to-production) cubre la primera parte. --- Jamak construye agentes de producción con el harness incluido. Primero corremos agentes en nuestros propios productos. El trabajo de agentes es [Agentes de IA](/es/services/ai-agents). El trabajo de adopción es [Implementación de IA](/es/services/ai-implementation). Háblanos. Sin tarifa publicada."
      }
    ],
    "keyTakeaways": []
  },
  {
    "id": 42,
    "slug": "es-ai-pilot-to-production",
    "title": "Por qué los pilotos de IA se atoran antes de producción, y cómo elegir uno que sí llegue",
    "excerpt": "La mayoría de los pilotos fallan en la elección, no en la construcción. Un flujo, un dueño, un número. Conectado al stack que ya tienes.",
    "author": {
      "name": "José Antonio Mijares",
      "role": "Founder & AI Strategist",
      "avatar": "/images/team/jose-mijares.png",
      "twitter": "@joseamijares"
    },
    "category": "AI",
    "tags": [
      "Implementación de IA",
      "Adopción de IA",
      "Piloto de IA",
      "Integración de LLM",
      "Estrategia de IA"
    ],
    "publishedAt": "2026-10-02",
    "modifiedAt": "2026-10-02",
    "readingTime": "6 min de lectura",
    "featuredImage": "/images/blog/ai-pilot-to-production-cover.webp",
    "featuredImageSize": {
      "width": 1600,
      "height": 1000
    },
    "figures": [
      {
        "src": "/images/blog/ai-pilot-to-production-explainer-es.webp",
        "alt": "Cinco filtros para elegir un piloto de IA: un flujo que una persona hace hoy, un dueño en ese equipo, un número que ya existe, datos del sistema real y no una exportación, y un fallo seguro donde una persona revisa primero.",
        "caption": "Pasa cada candidato por estos cinco filtros y descarta el que falle uno.",
        "width": 1600,
        "height": 900
      }
    ],
    "seoKeywords": [
      "piloto de IA a producción",
      "implementación de IA",
      "estrategia de adopción de IA",
      "por qué fallan los pilotos de IA",
      "integración de IA"
    ],
    "faqSchema": [
      {
        "question": "¿Cuánto debe durar un piloto de IA?",
        "answer": "Un flujo, construido dentro del stack existente, normalmente toma semanas, no meses. Si el plan dice un año, el alcance es un programa, no un piloto."
      },
      {
        "question": "¿Cuál es un buen primer caso de uso de IA?",
        "answer": "Trabajo repetitivo que una persona ya hace con texto o documentos: redactar respuestas, clasificar solicitudes, extraer campos, resumir llamadas. Tiene dueño, número y un paso de revisión seguro."
      },
      {
        "question": "¿Necesitamos primero un equipo de datos?",
        "answer": "No para la mayoría de los primeros pilotos. Necesitas acceso al sistema donde pasa el trabajo y una persona que sepa cómo se ve una buena respuesta."
      },
      {
        "question": "¿Construir o comprar?",
        "answer": "Compra cuando una herramienta existente ya hace exactamente esa tarea dentro de un sistema que usas. Construye cuando la tarea depende de tus datos, tus reglas y tu stack."
      },
      {
        "question": "¿Cuándo entran los agentes?",
        "answer": "Cuando la tarea necesita criterio a lo largo de varios pasos y herramientas. Muchos primeros pilotos no son agentes y no deberían serlo. [Qué hace que un agente esté listo para producción](/es/blog/es-ai-agent-production-harness) cubre ese lado. --- Jamak implementa IA dentro del stack que ya operas, y se la entrega a tu equipo. Lanzamos productos de IA propios, así que esto es implementación, no una presentación. El trabajo de adopción es [Implementación de IA](/es/services/ai-implementation). El trabajo de agentes es [Agentes de IA](/es/services/ai-agents). Háblanos. Sin tarifa publicada."
      }
    ],
    "keyTakeaways": []
  },
  {
    "id": 46,
    "slug": "es-saas-onboarding-first-session",
    "title": "¿Qué debe hacer un usuario nuevo de SaaS en su primera sesión?",
    "excerpt": "Una sola cosa. La acción que hace que valga la pena regresar. Todo lo demás del onboarding lleva ahí o espera.",
    "author": {
      "name": "José Antonio Mijares",
      "role": "Founder & AI Strategist",
      "avatar": "/images/team/jose-mijares.png",
      "twitter": "@joseamijares"
    },
    "category": "SaaS",
    "tags": [
      "SaaS",
      "Onboarding",
      "Activación",
      "Diseño de producto",
      "Retención"
    ],
    "publishedAt": "2026-10-02",
    "modifiedAt": "2026-10-02",
    "readingTime": "6 min de lectura",
    "featuredImage": "/images/blog/saas-onboarding-first-session-cover.webp",
    "featuredImageSize": {
      "width": 1600,
      "height": 1000
    },
    "figures": [
      {
        "src": "/images/blog/saas-onboarding-first-session-explainer-es.webp",
        "alt": "Flujo del registro al momento de activación, como una primera factura enviada, con cinco pasos tachados en medio: datos de perfil, invitar equipo, tour del producto, panel vacío y ajustes.",
        "caption": "Cada pantalla entre el registro y el primer resultado real es un lugar donde pierdes al usuario. Muévela para después o quítala.",
        "width": 1600,
        "height": 900
      }
    ],
    "seoKeywords": [
      "onboarding SaaS",
      "activación SaaS",
      "onboarding primera sesión",
      "métrica de activación",
      "checklist de onboarding"
    ],
    "faqSchema": [
      {
        "question": "¿Qué es una métrica de activación?",
        "answer": "El porcentaje de usuarios nuevos que completa la acción más ligada a quedarse. Es específica de tu producto: una factura enviada, un proyecto compartido, una fuente de datos conectada."
      },
      {
        "question": "¿El onboarding debe ser un checklist?",
        "answer": "Un checklist corto ayuda cuando la activación necesita varios pasos. Déjalo solo con los pasos que llevan al momento de activación. Un checklist de todas las funciones es un tour con casillas."
      },
      {
        "question": "¿Debemos preguntar el rol del usuario al registrarse?",
        "answer": "Solo si la respuesta cambia lo que ve después. Si todos los roles ven la misma primera pantalla, la pregunta es un costo sin retorno."
      },
      {
        "question": "¿Qué tan rápido debe aparecer el primer resultado?",
        "answer": "Tan rápido como lo permita el producto, idealmente en la primera sesión. Si necesita tiempo de procesamiento, muestra el avance y avísale al usuario cuando esté listo."
      },
      {
        "question": "¿Sirven los correos de onboarding?",
        "answer": "Ayudan a que los usuarios que ya empezaron regresen a terminar. No arreglan una primera sesión que nunca entrega un resultado. --- Jamak diseña y construye productos SaaS, y opera los suyos. El trabajo de producto es [SaaS](/es/services/saas). El trabajo de conversión es [CRO](/es/services/cro). Háblanos. Sin tarifa publicada."
      }
    ],
    "keyTakeaways": []
  },
  {
    "id": 44,
    "slug": "es-shopify-app-audit-conversions",
    "title": "Cómo auditar las apps de tu Shopify antes de que te cuesten ventas",
    "excerpt": "Cada app agrega código a la tienda. Algunas se lo ganan. Haz la lista, mídelas y quita las que no pagan renta.",
    "author": {
      "name": "José Antonio Mijares",
      "role": "Founder & AI Strategist",
      "avatar": "/images/team/jose-mijares.png",
      "twitter": "@joseamijares"
    },
    "category": "CRO",
    "tags": [
      "Shopify",
      "Apps de Shopify",
      "Velocidad del sitio",
      "Optimización de conversión",
      "Ecommerce"
    ],
    "publishedAt": "2026-10-02",
    "modifiedAt": "2026-10-02",
    "readingTime": "6 min de lectura",
    "featuredImage": "/images/blog/shopify-app-audit-conversions-cover.webp",
    "featuredImageSize": {
      "width": 1600,
      "height": 1000
    },
    "figures": [
      {
        "src": "/images/blog/shopify-app-audit-conversions-explainer-es.webp",
        "alt": "Tres veredictos para cada app de la tienda Shopify: se queda si mueve un número visible, se prueba si el número no es claro quitándola y midiendo otra vez, y se va si nadie sabe qué número mueve; luego busca código sobrante en el tema.",
        "caption": "Cada app que carga en la tienda tiene que mostrar qué número mueve. Si nadie lo sabe, se va.",
        "width": 1600,
        "height": 900
      }
    ],
    "seoKeywords": [
      "auditoría de apps Shopify",
      "apps que hacen lenta mi tienda Shopify",
      "velocidad Shopify",
      "tasa de conversión Shopify",
      "quitar apps de Shopify"
    ],
    "faqSchema": [
      {
        "question": "¿Cuántas apps de Shopify son demasiadas?",
        "answer": "No hay un número seguro. Una sola app pesada en la página de producto puede costar más que diez apps de back office. Cuenta lo que carga en la tienda, no lo que está instalado."
      },
      {
        "question": "¿Desinstalar una app quita su código?",
        "answer": "Las apps nuevas construidas con theme app extensions se quitan limpias. Algunas apps viejas editaron directamente los archivos del theme, y ese código se puede quedar después de desinstalar. Busca el nombre de la app en el theme."
      },
      {
        "question": "¿Qué página debo probar primero?",
        "answer": "La página de tu producto más vendido, en celular. Es la que más ingresos carga y normalmente la que más apps tiene."
      },
      {
        "question": "¿Quitar apps sube mi tasa de conversión?",
        "answer": "No de forma automática. Quitar peso ayuda a que la página cargue. Si eso sube las ventas depende de lo que hacía la app. Quita, mide y luego decide."
      },
      {
        "question": "¿Cada cuánto debo auditar?",
        "answer": "Cada vez que agregas una app, y una vez por trimestre la lista completa. Las apps se actualizan, y lo que cargaba ligero el año pasado puede ya no hacerlo. --- Jamak es Shopify Select Partner. Shopify ha sido nuestro trabajo principal en tiendas desde 2020. El trabajo de tienda es [Shopify](/es/services/shopify). El trabajo de conversión es [CRO](/es/services/cro). Háblanos. Sin tarifa publicada. Sin resultados inventados."
      }
    ],
    "keyTakeaways": []
  },
  {
    "id": 48,
    "slug": "es-update-old-page-or-write-new",
    "title": "¿Actualizar una página vieja o escribir una nueva?",
    "excerpt": "Si una página ya rankea para la búsqueda, actualízala. Un post nuevo con la misma keyword compite con la página en la que Google ya confía.",
    "author": {
      "name": "José Antonio Mijares",
      "role": "Founder & AI Strategist",
      "avatar": "/images/team/jose-mijares.png",
      "twitter": "@joseamijares"
    },
    "category": "SEO",
    "tags": [
      "SEO",
      "Actualización de contenido",
      "Canibalización de keywords",
      "Search Console",
      "Estrategia de contenido"
    ],
    "publishedAt": "2026-10-02",
    "modifiedAt": "2026-10-02",
    "readingTime": "6 min de lectura",
    "featuredImage": "/images/blog/update-old-page-or-write-new-cover.webp",
    "featuredImageSize": {
      "width": 1600,
      "height": 1000
    },
    "figures": [
      {
        "src": "/images/blog/update-old-page-or-write-new-explainer-es.webp",
        "alt": "Cuatro resultados de Search Console para una consulta y qué hacer: una de tus páginas en posiciones 1 a 20, actualízala; dos o más de tus páginas, fusiónalas y redirige la más débil; una página cubre el tema sin datos, actualízala primero; ninguna página cubre el tema, escribe una nueva.",
        "caption": "Search Console lo decide consulta por consulta: actualizar, fusionar o escribir nueva.",
        "width": 1600,
        "height": 900
      }
    ],
    "seoKeywords": [
      "actualizar post viejo o escribir nuevo",
      "actualización de contenido SEO",
      "canibalización de keywords",
      "actualizar contenido viejo",
      "auditoría de contenido Search Console"
    ],
    "faqSchema": [
      {
        "question": "¿Actualizar un post viejo ayuda al SEO?",
        "answer": "Cuando la actualización vuelve a la página una mejor respuesta a la búsqueda para la que rankea, sí. Cambiar solo la fecha, no."
      },
      {
        "question": "¿Qué es la canibalización de keywords?",
        "answer": "Dos o más de tus propias páginas compitiendo por la misma búsqueda. Search Console lo muestra cuando varias de tus URLs reciben impresiones para una misma consulta. Júntalas en la página más fuerte y redirige la otra."
      },
      {
        "question": "¿Debo cambiar la URL cuando actualizo?",
        "answer": "No, a menos que la URL vieja esté rota o confunda. Si la cambias, agrega un redirect 301 desde la URL vieja."
      },
      {
        "question": "¿Cada cuánto debo actualizar contenido?",
        "answer": "Revisa cada pocos meses las páginas que traen tráfico o leads. Actualiza cuando algo está viejo o cuando bajan las posiciones. No con un calendario fijo nada más porque sí."
      },
      {
        "question": "¿Esto importa también para las respuestas de IA?",
        "answer": "Sí. Una página clara por tema, con la respuesta arriba, es más fácil de citar para ChatGPT, Perplexity y AI Overviews que tres posts que se enciman. [Cómo checar si te citan](/es/blog/es-how-to-check-if-chatgpt-cites-your-brand) es el método. --- Jamak hace SEO y GEO para tiendas y SaaS. El trabajo de posicionamiento es [SEO](/es/services/seo). El trabajo de citación es [GEO](/es/services/geo). Háblanos. Sin tarifa publicada. Sin resultados inventados."
      }
    ],
    "keyTakeaways": []
  },
  {
    "id": 45,
    "slug": "saas-onboarding-first-session",
    "title": "What should a new SaaS user do in the first session?",
    "excerpt": "One thing. The action that makes the product worth coming back to. Everything else in onboarding either leads there or waits.",
    "author": {
      "name": "José Antonio Mijares",
      "role": "Founder & AI Strategist",
      "avatar": "/images/team/jose-mijares.png",
      "twitter": "@joseamijares"
    },
    "category": "SaaS",
    "tags": [
      "SaaS",
      "Onboarding",
      "Activation",
      "Product design",
      "Retention"
    ],
    "publishedAt": "2026-10-02",
    "modifiedAt": "2026-10-02",
    "readingTime": "6 min read",
    "featuredImage": "/images/blog/saas-onboarding-first-session-cover.webp",
    "featuredImageSize": {
      "width": 1600,
      "height": 1000
    },
    "figures": [
      {
        "src": "/images/blog/saas-onboarding-first-session-explainer-en.webp",
        "alt": "Flow from signup to the activation moment, such as a first invoice sent, with five steps crossed out in between: profile fields, team invites, product tour, empty dashboard and settings.",
        "caption": "Every screen between signup and the first real result is a place to lose the user. Move it later or remove it.",
        "width": 1600,
        "height": 900
      }
    ],
    "seoKeywords": [
      "SaaS onboarding",
      "SaaS activation",
      "first session onboarding",
      "user activation metric",
      "onboarding checklist"
    ],
    "faqSchema": [
      {
        "question": "What is an activation metric?",
        "answer": "The share of new users who complete the action most linked to staying. It is specific to your product: a sent invoice, a shared project, a connected data source."
      },
      {
        "question": "Should onboarding be a checklist?",
        "answer": "A short checklist helps when activation needs a few steps. Keep it to the steps that lead to the activation moment. A checklist of every feature is a tour with checkboxes."
      },
      {
        "question": "Should we ask users their role at signup?",
        "answer": "Only if the answer changes what they see next. If every role gets the same first screen, the question is a cost with no return."
      },
      {
        "question": "How fast should the first result appear?",
        "answer": "As fast as the product allows, ideally within the first session. If it needs processing time, show progress and notify the user when it is ready."
      },
      {
        "question": "Do onboarding emails help?",
        "answer": "They help users who already started come back to finish. They do not fix a first session that never delivers a result. --- Jamak designs and builds SaaS products, and runs its own. The product work is [SaaS](/services/saas). The conversion work is [CRO](/services/cro). Talk to us. No rate card."
      }
    ],
    "keyTakeaways": []
  },
  {
    "id": 43,
    "slug": "shopify-app-audit-conversions",
    "title": "How to audit your Shopify apps before they cost you sales",
    "excerpt": "Every app adds code to the storefront. Some earn it. List them, measure them, remove the ones that don't pay rent.",
    "author": {
      "name": "José Antonio Mijares",
      "role": "Founder & AI Strategist",
      "avatar": "/images/team/jose-mijares.png",
      "twitter": "@joseamijares"
    },
    "category": "CRO",
    "tags": [
      "Shopify",
      "Shopify apps",
      "Site speed",
      "Conversion rate optimization",
      "Ecommerce"
    ],
    "publishedAt": "2026-10-02",
    "modifiedAt": "2026-10-02",
    "readingTime": "6 min read",
    "featuredImage": "/images/blog/shopify-app-audit-conversions-cover.webp",
    "featuredImageSize": {
      "width": 1600,
      "height": 1000
    },
    "figures": [
      {
        "src": "/images/blog/shopify-app-audit-conversions-explainer-en.webp",
        "alt": "Three verdicts for each Shopify storefront app: keep it if it moves a number you can see, test it if the number is unclear by removing it and measuring the page again, and remove it if nobody can name its number, then search the theme for leftover code.",
        "caption": "Each app that loads on the storefront has to show the number it moves. If nobody can name one, it goes.",
        "width": 1600,
        "height": 900
      }
    ],
    "seoKeywords": [
      "Shopify app audit",
      "Shopify apps slowing store",
      "Shopify speed",
      "Shopify conversion rate",
      "remove Shopify apps"
    ],
    "faqSchema": [
      {
        "question": "How many Shopify apps is too many?",
        "answer": "There is no safe number. One heavy app on the product page can cost more than ten back-office apps. Count what loads on the storefront, not what is installed."
      },
      {
        "question": "Does uninstalling an app remove its code?",
        "answer": "Newer apps built on theme app extensions are removed cleanly. Some older apps edited theme files directly, and that code can stay after uninstalling. Search the theme for the app's name."
      },
      {
        "question": "Which page should I test first?",
        "answer": "Your best-selling product page on mobile. It carries the most revenue and usually the most apps."
      },
      {
        "question": "Will removing apps raise my conversion rate?",
        "answer": "Not automatically. Removing weight helps the page load. Whether it lifts sales depends on what the app did. Remove, measure, then decide."
      },
      {
        "question": "How often should I audit?",
        "answer": "Every time you add an app, and once a quarter for the full list. Apps update, and what loaded lightly last year may not now. --- Jamak is a Shopify Select Partner. Shopify has been the main store work since 2020. The store work is [Shopify](/services/shopify). The conversion work is [CRO](/services/cro). Talk to us. No rate card. No fake results."
      }
    ],
    "keyTakeaways": []
  },
  {
    "id": 47,
    "slug": "update-old-page-or-write-new",
    "title": "Should you update an old page or write a new one?",
    "excerpt": "If a page already ranks for the query, update it. A new post on the same keyword competes with the page Google already trusts.",
    "author": {
      "name": "José Antonio Mijares",
      "role": "Founder & AI Strategist",
      "avatar": "/images/team/jose-mijares.png",
      "twitter": "@joseamijares"
    },
    "category": "SEO",
    "tags": [
      "SEO",
      "Content refresh",
      "Keyword cannibalization",
      "Search Console",
      "Content strategy"
    ],
    "publishedAt": "2026-10-02",
    "modifiedAt": "2026-10-02",
    "readingTime": "6 min read",
    "featuredImage": "/images/blog/update-old-page-or-write-new-cover.webp",
    "featuredImageSize": {
      "width": 1600,
      "height": 1000
    },
    "figures": [
      {
        "src": "/images/blog/update-old-page-or-write-new-explainer-en.webp",
        "alt": "Four Search Console outcomes for a query and what to do: one of your pages in positions 1 to 20, update it; two or more of your pages, merge them and redirect the weaker URL; a page covers the topic but gets no impressions, update it first; no page covers the topic, write a new one.",
        "caption": "Search Console decides it per query: update, merge, or write new.",
        "width": 1600,
        "height": 900
      }
    ],
    "seoKeywords": [
      "update old blog post or write new",
      "content refresh SEO",
      "keyword cannibalization",
      "refresh old content",
      "Search Console content audit"
    ],
    "faqSchema": [
      {
        "question": "Does updating an old post help SEO?",
        "answer": "When the update makes the page a better answer to the query it ranks for, yes. Changing only the date does not."
      },
      {
        "question": "What is keyword cannibalization?",
        "answer": "Two or more of your own pages competing for the same query. Search Console shows it when several of your URLs get impressions for one query. Merge them into the stronger page and redirect the other."
      },
      {
        "question": "Should I change the URL when I update?",
        "answer": "No, unless the old URL is broken or misleading. If you change it, add a 301 redirect from the old URL."
      },
      {
        "question": "How often should I refresh content?",
        "answer": "Check pages that bring traffic or leads every few months. Update when something is stale or when positions drop. Not on a fixed schedule for its own sake."
      },
      {
        "question": "Does this matter for AI answers too?",
        "answer": "Yes. One clear page per topic, with the answer at the top, is easier for ChatGPT, Perplexity, and AI Overviews to cite than three overlapping posts. [How to check if they cite you](/blog/how-to-check-if-chatgpt-cites-your-brand) is the method. --- Jamak does SEO and GEO for stores and SaaS. The ranking work is [SEO](/services/seo). The citation work is [GEO](/services/geo). Talk to us. No rate card. No fake results."
      }
    ],
    "keyTakeaways": []
  },
  {
    "id": 38,
    "slug": "github-actions-hetzner-vps-ci",
    "title": "GitHub Actions hit our $100 cap. Linux CI now runs on a Hetzner VPS.",
    "excerpt": "Hosted Actions stopped starting jobs after we blew a $100 monthly cap. Linux CI moved to a Helsinki VPS. Deploys stayed on Vercel. This is what moved, what did not, and what we will not do again.",
    "author": {
      "name": "José Antonio Mijares",
      "role": "Founder & AI Strategist",
      "avatar": "/images/team/jose-mijares.png",
      "twitter": "@joseamijares"
    },
    "category": "SaaS",
    "tags": [
      "GitHub Actions",
      "CI",
      "Hetzner",
      "DevOps",
      "Cost"
    ],
    "publishedAt": "2026-08-26",
    "modifiedAt": "2026-08-26",
    "canonical": "https://joseamijares.com/blog/github-actions-hetzner-vps-ci",
    "readingTime": "8 min read",
    "featuredImage": "/images/blog/github-actions-hetzner-vps-ci-cover.webp",
    "featuredImageSize": {
      "width": 1600,
      "height": 1000
    },
    "figures": [
      {
        "src": "/images/blog/github-actions-hetzner-vps-ci-1.png",
        "alt": "122 vs 7. Not a nightly. Every push to main.",
        "width": 1920,
        "height": 1084
      },
      {
        "src": "/images/blog/github-actions-hetzner-vps-ci-2.png",
        "alt": "Linux CI on the VPS. Deploys, iOS, and jamaklab CI did not move.",
        "width": 1920,
        "height": 1084
      }
    ],
    "seoKeywords": [
      "GitHub Actions spend cap",
      "self-hosted GitHub runner Hetzner",
      "GitHub Actions too expensive",
      "move CI off GitHub-hosted runners",
      "GitHub Actions $100 spending limit"
    ],
    "faqSchema": [],
    "keyTakeaways": []
  },
  {
    "id": 37,
    "slug": "es-ai-search-replacing-google-brand-visibility-2026",
    "title": "La búsqueda con IA está reemplazando a Google: ¿tu marca es visible?",
    "excerpt": "Un ranking en Google no es una citación de IA. Checa ChatGPT, Claude, Perplexity, Gemini, Grok y AI Overviews. Luego arregla la URL que ya rankea.",
    "author": {
      "name": "José Antonio Mijares",
      "role": "Founder & AI Strategist",
      "avatar": "/images/team/jose-mijares.png",
      "twitter": "@joseamijares"
    },
    "category": "GEO",
    "tags": [
      "GEO",
      "Búsqueda con IA",
      "Visibilidad en IA",
      "Estrategia de marca",
      "Optimización para motores generativos",
      "Marketing 2026"
    ],
    "publishedAt": "2026-08-17",
    "modifiedAt": "2026-08-17",
    "readingTime": "6 min de lectura",
    "featuredImage": "/images/blog/ai-search-replacing-google-brand-visibility-2026-cover.webp",
    "featuredImageSize": {
      "width": 1600,
      "height": 1000
    },
    "figures": [
      {
        "src": "/images/blog/ai-search-replacing-google-brand-visibility-2026-1.png",
        "alt": "Seis superficies de IA junto a los rankings ordinarios de Google",
        "width": 1600,
        "height": 900
      },
      {
        "src": "/images/blog/ai-search-replacing-google-brand-visibility-2026-2.png",
        "alt": "Un log de citación: la URL que rankea, las seis superficies, te nombran o no",
        "width": 1600,
        "height": 900
      }
    ],
    "seoKeywords": [
      "búsqueda IA reemplaza Google",
      "visibilidad de marca en IA",
      "GEO generative engine optimization",
      "visibilidad de marca plataformas IA",
      "optimización AI Overviews"
    ],
    "faqSchema": [
      {
        "question": "¿Qué es GEO (Generative Engine Optimization)?",
        "answer": "GEO es que te citen dentro de respuestas de IA en ChatGPT, Claude, Perplexity, Gemini, Grok y Google AI Overviews. SEO es páginas rankeadas en Google. Las mismas páginas deberían hacer las dos cosas. GEO no es SEO local."
      },
      {
        "question": "¿Cómo checo si mi marca aparece en respuestas de IA?",
        "answer": "Usa queries en las que ya rankeas. Pregunta el mismo prompt en las seis superficies. Abre las fuentes de Perplexity. Mira si un AI Overview te nombra. Anota a quién nombran. No hace falta un dashboard."
      },
      {
        "question": "¿GEO reemplaza al SEO?",
        "answer": "No. GEO extiende el SEO. Una URL que rankea sin hechos no va a ser citada. Una página citada igual necesita rankear y convertir. Un solo set de páginas."
      },
      {
        "question": "¿Por qué rankearía y seguiría invisible?",
        "answer": "La URL que rankea probablemente es un template: una grilla, un PDP vacío o dos páginas que no coinciden. Los motores de respuestas saltan páginas que no pueden usar como fuente."
      },
      {
        "question": "¿Qué superficie importa más?",
        "answer": "Checa las seis. No comparten un solo índice. Un nombre en Perplexity no es un nombre en ChatGPT. No elijas una favorita e ignores el resto."
      }
    ],
    "keyTakeaways": [
      {
        "title": "Rankear no es citar:",
        "description": "Estar en la página uno de Google no te pone en la respuesta."
      },
      {
        "title": "Seis superficies, no una:",
        "description": "ChatGPT, Claude, Perplexity, Gemini, Grok y AI Overviews. No Copilot. No Reddit."
      },
      {
        "title": "Usa queries en las que ya rankeas:",
        "description": "Arregla esa URL. No empieces un blog nuevo con la misma keyword."
      },
      {
        "title": "Sin tasas inventadas:",
        "description": "Nombrado o no es la métrica. No publiques un porcentaje de citación que no puedas sourcer."
      },
      {
        "title": "SEO y GEO son un solo trabajo:",
        "description": "Rankeado en Google, citado en la respuesta. [GEO](/es/services/geo)."
      }
    ]
  },
  {
    "id": 36,
    "slug": "es-how-to-check-if-chatgpt-cites-your-brand",
    "title": "¿Cómo checo si ChatGPT, Perplexity o AI Overviews citan mi marca?",
    "excerpt": "Usa las queries en las que ya rankeas. Pregunta en las seis superficies. Anota a quién nombran. No hace falta un dashboard.",
    "author": {
      "name": "José Antonio Mijares",
      "role": "Founder & AI Strategist",
      "avatar": "/images/team/jose-mijares.png",
      "twitter": "@joseamijares"
    },
    "category": "GEO",
    "tags": [
      "GEO",
      "ChatGPT",
      "Perplexity",
      "AI Overviews",
      "Visibilidad de marca",
      "Optimización para motores generativos"
    ],
    "publishedAt": "2026-08-17",
    "modifiedAt": "2026-08-17",
    "readingTime": "7 min de lectura",
    "featuredImage": "/images/blog/how-to-check-if-chatgpt-cites-your-brand-cover.webp",
    "featuredImageSize": {
      "width": 1600,
      "height": 1000
    },
    "figures": [
      {
        "src": "/images/blog/how-to-check-if-chatgpt-cites-your-brand-1.png",
        "alt": "Queries de Search Console mapeadas a los mismos prompts en seis superficies de IA",
        "width": 1600,
        "height": 900
      },
      {
        "src": "/images/blog/how-to-check-if-chatgpt-cites-your-brand-2.png",
        "alt": "Un log de citación: query, superficie, te nombran o no, y la URL que rankea y hay que arreglar",
        "width": 1600,
        "height": 900
      }
    ],
    "seoKeywords": [
      "checar si ChatGPT cita mi marca",
      "citación de marca Perplexity",
      "checar citación AI Overviews",
      "auditoría GEO",
      "visibilidad en IA"
    ],
    "faqSchema": [
      {
        "question": "¿Necesito una herramienta paga de visibilidad en IA para checar citas?",
        "answer": "No. Search Console te da las queries. Las seis superficies son públicas. Una hoja es el reporte. Un dashboard puede guardar el log. No puede reemplazar los prompts."
      },
      {
        "question": "¿Qué superficies debo checar?",
        "answer": "Seis: ChatGPT, Claude, Perplexity, Gemini, Grok y Google AI Overviews. No Copilot. Reddit es comunidad y PR, no un sexto motor."
      },
      {
        "question": "¿Qué hago si rankeo y nunca me nombran?",
        "answer": "La URL que rankea probablemente no es citable. Agrégale hechos que un modelo pueda levantar. No empieces un blog nuevo con la misma keyword. Ve la [versión Shopify de esta brecha](/es/blog/es-shopify-store-ranks-google-chatgpt-never-mentions-it) si la URL es una colección o un PDP flaco."
      },
      {
        "question": "¿Cada cuánto vuelvo a correr el chequeo?",
        "answer": "Después de cambiar la URL que rankea, corre los mismos prompts otra vez. Cada semana mientras editas. Cada mes cuando el log esté estable. No agregues una lista nueva de queries cada semana."
      },
      {
        "question": "¿Aparecer en las fuentes de Perplexity significa que voy a aparecer en ChatGPT?",
        "answer": "No. Las superficies no comparten un solo índice. Un enlace de fuente en Perplexity es una buena señal para esa superficie. Checa las otras cinco. Rankear sigue sin ser citar. --- El trabajo es citas en esas seis superficies. Eso es [GEO](/es/services/geo). Háblanos si quieres que corramos el log y arreglemos las URLs que rankean. Sin tarifa publicada. Sin resultados inventados."
      }
    ],
    "keyTakeaways": []
  },
  {
    "id": 34,
    "slug": "es-shopify-store-ranks-google-chatgpt-never-mentions-it",
    "title": "¿Por qué mi tienda Shopify rankea en Google pero ChatGPT nunca me menciona?",
    "excerpt": "Google rankea páginas. ChatGPT cita páginas que puede usar como fuente. Son trabajos distintos.",
    "author": {
      "name": "José Antonio Mijares",
      "role": "Founder & AI Strategist",
      "avatar": "/images/team/jose-mijares.png",
      "twitter": "@joseamijares"
    },
    "category": "GEO",
    "tags": [
      "GEO",
      "Shopify",
      "ChatGPT",
      "Búsqueda con IA",
      "Optimización para motores generativos"
    ],
    "publishedAt": "2026-08-17",
    "modifiedAt": "2026-11-03",
    "readingTime": "7 min de lectura",
    "featuredImage": "/images/blog/shopify-store-ranks-google-chatgpt-never-mentions-it-cover.webp",
    "featuredImageSize": {
      "width": 1600,
      "height": 1000
    },
    "figures": [
      {
        "src": "/images/blog/shopify-store-ranks-google-chatgpt-never-mentions-it-1.png",
        "alt": "Una colección de Shopify que rankea como grilla de productos sin hechos que un modelo pueda levantar",
        "width": 1600,
        "height": 900
      },
      {
        "src": "/images/blog/shopify-store-ranks-google-chatgpt-never-mentions-it-2.png",
        "alt": "Una página de producto con hechos con nombre que un modelo puede citar, junto a un template sin ninguno",
        "width": 1600,
        "height": 900
      }
    ],
    "seoKeywords": [
      "Shopify ChatGPT",
      "Shopify GEO",
      "por qué ChatGPT no menciona mi tienda",
      "ranking Google vs citación IA",
      "GEO Shopify"
    ],
    "faqSchema": [
      {
        "question": "Si rankeo #1, ¿por qué ChatGPT no me mencionaría?",
        "answer": "Porque rankear y ser citado son trabajos distintos. Google puede rankear una grilla de colección. ChatGPT, Perplexity, Claude, Gemini, Grok y AI Overviews necesitan una oración que puedan usar como fuente: un producto con nombre, un material, un lugar, una fecha. Una URL en página uno sin hechos es fácil de saltar."
      },
      {
        "question": "¿Necesito un theme nuevo de Shopify?",
        "answer": "No. Cambiar el theme no agrega hechos. Si la URL que rankea es un template con cards y una barra de filtros, reescribe esa URL. El theme no es la brecha."
      },
      {
        "question": "¿Basta con un blog?",
        "answer": "No. Un post que reformula el título de la colección no hace citable a la colección. Pon una respuesta corta en la URL que ya rankea. No empieces un cluster nuevo con la misma keyword."
      },
      {
        "question": "¿Cómo checo si me citan?",
        "answer": "Usa queries en las que ya rankeas en Search Console. Pregunta la misma query en ChatGPT, luego una de marca. Repite en Perplexity y abre las fuentes. Mira si un AI Overview te nombra. Corre Claude, Gemini y Grok igual. Anota a quién nombran."
      },
      {
        "question": "¿Cuál es la primera página que debo arreglar?",
        "answer": "La URL que ya rankea y no tiene hechos que un modelo pueda levantar. Suele ser una colección o un PDP flaco. About es la siguiente si la historia de marca contradice las páginas de producto. --- Jamak es Shopify Select Partner. Shopify es el trabajo principal de tiendas desde 2020. El trabajo de citación es [GEO](/es/services/geo). El de ranking es [SEO](/es/services/seo). El de la tienda es [Shopify](/es/services/shopify). Háblanos. Sin tarifa publicada. Sin resultados inventados."
      }
    ],
    "keyTakeaways": []
  },
  {
    "id": 35,
    "slug": "how-to-check-if-chatgpt-cites-your-brand",
    "title": "How do I check if ChatGPT, Perplexity, or AI Overviews cite my brand?",
    "excerpt": "Use the queries you already rank for. Ask the six surfaces. Log who is named. No dashboard required.",
    "author": {
      "name": "José Antonio Mijares",
      "role": "Founder & AI Strategist",
      "avatar": "/images/team/jose-mijares.png",
      "twitter": "@joseamijares"
    },
    "category": "GEO",
    "tags": [
      "GEO",
      "ChatGPT",
      "Perplexity",
      "AI Overviews",
      "Brand visibility",
      "Generative Engine Optimization"
    ],
    "publishedAt": "2026-08-17",
    "modifiedAt": "2026-08-17",
    "readingTime": "7 min read",
    "featuredImage": "/images/blog/how-to-check-if-chatgpt-cites-your-brand-cover.webp",
    "featuredImageSize": {
      "width": 1600,
      "height": 1000
    },
    "figures": [
      {
        "src": "/images/blog/how-to-check-if-chatgpt-cites-your-brand-1.png",
        "alt": "Search Console queries mapped to the same prompts on six AI surfaces",
        "width": 1600,
        "height": 900
      },
      {
        "src": "/images/blog/how-to-check-if-chatgpt-cites-your-brand-2.png",
        "alt": "A citation log: query, surface, named or not, then the ranking URL to fix",
        "width": 1600,
        "height": 900
      }
    ],
    "seoKeywords": [
      "check if ChatGPT cites my brand",
      "Perplexity brand citation",
      "AI Overviews citation check",
      "GEO audit",
      "AI visibility"
    ],
    "faqSchema": [
      {
        "question": "Do I need a paid AI visibility tool to check citations?",
        "answer": "No. Search Console gives you the queries. The six surfaces are public. A sheet is the report. A dashboard can store the log. It cannot replace the prompts."
      },
      {
        "question": "Which surfaces should I check?",
        "answer": "Six: ChatGPT, Claude, Perplexity, Gemini, Grok, and Google AI Overviews. Not Copilot. Reddit is community and PR, not a sixth engine."
      },
      {
        "question": "What if I rank and I am never named?",
        "answer": "The ranking URL is probably not citable. Add facts a model can lift. Do not start a new blog on the same keyword. See the [Shopify version of this gap](/blog/shopify-store-ranks-google-chatgpt-never-mentions-it) if the URL is a collection or a thin PDP."
      },
      {
        "question": "How often should I re-run the check?",
        "answer": "After you change the ranking URL, run the same prompts again. Weekly while you are editing. Monthly when the log is stable. Do not add a new query list every week."
      },
      {
        "question": "Does appearing in Perplexity’s sources mean I will appear in ChatGPT?",
        "answer": "No. The surfaces do not share one index. A source link in Perplexity is a good sign for that surface. Check the other five. Rank is still not a cite. --- The work is citations on those six surfaces. That is [GEO](/services/geo). Talk to us if you want the log run and the ranking URLs fixed. No rate card. No fake results."
      }
    ],
    "keyTakeaways": []
  },
  {
    "id": 33,
    "slug": "shopify-store-ranks-google-chatgpt-never-mentions-it",
    "title": "Why does my Shopify store rank on Google but ChatGPT never mentions it?",
    "excerpt": "Google ranks pages. ChatGPT cites pages it can use as a source. Those are different jobs.",
    "author": {
      "name": "José Antonio Mijares",
      "role": "Founder & AI Strategist",
      "avatar": "/images/team/jose-mijares.png",
      "twitter": "@joseamijares"
    },
    "category": "GEO",
    "tags": [
      "GEO",
      "Shopify",
      "ChatGPT",
      "AI Search",
      "Generative Engine Optimization"
    ],
    "publishedAt": "2026-08-17",
    "modifiedAt": "2026-11-03",
    "readingTime": "7 min read",
    "featuredImage": "/images/blog/shopify-store-ranks-google-chatgpt-never-mentions-it-cover.webp",
    "featuredImageSize": {
      "width": 1600,
      "height": 1000
    },
    "figures": [
      {
        "src": "/images/blog/shopify-store-ranks-google-chatgpt-never-mentions-it-1.png",
        "alt": "A Shopify collection that ranks as a product grid with no facts a model can lift",
        "width": 1600,
        "height": 900
      },
      {
        "src": "/images/blog/shopify-store-ranks-google-chatgpt-never-mentions-it-2.png",
        "alt": "A product page with named facts a model can cite next to a template page with none",
        "width": 1600,
        "height": 900
      }
    ],
    "seoKeywords": [
      "Shopify ChatGPT",
      "Shopify GEO",
      "why ChatGPT does not mention my store",
      "Google rank vs AI citation",
      "generative engine optimization Shopify"
    ],
    "faqSchema": [
      {
        "question": "If I rank #1, why wouldn’t ChatGPT mention me?",
        "answer": "Because ranking and citation are different jobs. Google can rank a collection grid. ChatGPT, Perplexity, Claude, Gemini, Grok, and AI Overviews need a sentence they can use as a source: a named product, a material, a place, a date. A page-one URL with no facts is easy to skip."
      },
      {
        "question": "Do I need a new Shopify theme?",
        "answer": "No. A theme change does not add facts. If the ranking URL is a template with cards and a filter bar, rewrite that URL. The theme is not the gap."
      },
      {
        "question": "Is a blog enough?",
        "answer": "No. A post that restates the collection title does not make the collection citable. Put a short answer on the URL that already ranks. Do not start a new cluster on the same keyword."
      },
      {
        "question": "How do I check if I’m cited?",
        "answer": "Use queries you already rank for in Search Console. Ask the same query on ChatGPT, then a brand query. Repeat on Perplexity and open the sources. Check whether an AI Overview names you. Run Claude, Gemini, and Grok the same way. Log who is named."
      },
      {
        "question": "What’s the first page to fix?",
        "answer": "The URL that already ranks and has no facts a model can lift. Usually a collection or a thin PDP. About is next if the brand story contradicts the product pages. --- Jamak is a Shopify Select Partner. Shopify has been the main store work since 2020. The citation work is [GEO](/services/geo). The ranking work is [SEO](/services/seo). The store work is [Shopify](/services/shopify). Talk to us. No rate card. No fake results."
      }
    ],
    "keyTakeaways": []
  },
  {
    "id": 25,
    "slug": "ai-search-replacing-google-brand-visibility-2026",
    "title": "AI Search Is Replacing Google: Is Your Brand Visible?",
    "excerpt": "A Google rank is not an AI citation. Check ChatGPT, Claude, Perplexity, Gemini, Grok, and AI Overviews. Then fix the URL that already ranks.",
    "author": {
      "name": "José Antonio Mijares",
      "role": "Founder & AI Strategist",
      "avatar": "/images/team/jose-mijares.png",
      "twitter": "@joseamijares"
    },
    "category": "GEO",
    "tags": [
      "GEO",
      "AI Search",
      "AI Visibility",
      "Brand Strategy",
      "Generative Engine Optimization",
      "2026 Marketing"
    ],
    "publishedAt": "2026-02-18",
    "modifiedAt": "2026-02-18",
    "readingTime": "6 min read",
    "featuredImage": "/images/blog/ai-search-replacing-google-brand-visibility-2026-cover.webp",
    "featuredImageSize": {
      "width": 1600,
      "height": 1000
    },
    "figures": [
      {
        "src": "/images/blog/ai-search-replacing-google-brand-visibility-2026-1.png",
        "alt": "Six AI surfaces next to ordinary Google rankings",
        "width": 1600,
        "height": 900
      },
      {
        "src": "/images/blog/ai-search-replacing-google-brand-visibility-2026-2.png",
        "alt": "A citation log: the ranking URL, the six surfaces, named or not",
        "width": 1600,
        "height": 900
      }
    ],
    "seoKeywords": [
      "AI search replacing Google",
      "AI visibility for brands",
      "GEO generative engine optimization",
      "brand visibility AI platforms",
      "AI Overviews optimization"
    ],
    "faqSchema": [
      {
        "question": "What is GEO (Generative Engine Optimization)?",
        "answer": "GEO is getting cited inside AI answers on ChatGPT, Claude, Perplexity, Gemini, Grok, and Google AI Overviews. SEO is ranked pages in Google. The same pages should do both. GEO is not local SEO."
      },
      {
        "question": "How do I check if my brand appears in AI answers?",
        "answer": "Use queries you already rank for. Ask the same prompt on all six surfaces. Open Perplexity’s sources. See whether an AI Overview names you. Log who is named. No dashboard required."
      },
      {
        "question": "Does GEO replace SEO?",
        "answer": "No. GEO extends SEO. A ranking URL with no facts will not be cited. A cited page still needs to rank and convert. One set of pages."
      },
      {
        "question": "Why would I rank and still be invisible?",
        "answer": "The ranking URL is probably a template: a grid, an empty PDP, or two pages that disagree. Answer engines skip pages they cannot use as a source."
      },
      {
        "question": "Which surface matters most?",
        "answer": "Check all six. They do not share one index. A name in Perplexity is not a name in ChatGPT. Do not pick a favorite and ignore the rest."
      }
    ],
    "keyTakeaways": [
      {
        "title": "Rank is not a cite:",
        "description": "Page one in Google does not put you in the answer."
      },
      {
        "title": "Six surfaces, not one:",
        "description": "ChatGPT, Claude, Perplexity, Gemini, Grok, and AI Overviews. Not Copilot. Not Reddit."
      },
      {
        "title": "Use queries you already rank for:",
        "description": "Fix that URL. Do not start a new blog on the same keyword."
      },
      {
        "title": "No invented rates:",
        "description": "Named or not is the metric. Do not publish a citation percentage you cannot source."
      },
      {
        "title": "SEO and GEO are one job:",
        "description": "Ranked in Google, cited in the answer. [GEO](/services/geo)."
      }
    ]
  },
  {
    "id": 24,
    "slug": "es-ab-testing-mistakes-kill-conversions",
    "title": "Errores de Pruebas A/B que Destruyen tus Conversiones",
    "excerpt": "Siete errores de A/B testing que producen ganadores falsos: parar temprano, probar todo a la vez, ignorar segmentos. Cómo evitarlos.",
    "author": {
      "name": "José Antonio Mijares",
      "role": "Founder & AI Strategist",
      "avatar": "/images/team/jose-mijares.png",
      "twitter": "@joseamijares"
    },
    "category": "CRO",
    "tags": [
      "Pruebas A/B",
      "CRO",
      "Optimización de Conversiones",
      "Significancia Estadística",
      "Estrategia de Testing",
      "Experimentación"
    ],
    "publishedAt": "2026-01-23",
    "modifiedAt": "2026-01-23",
    "readingTime": "7 min de lectura",
    "featuredImage": "/images/blog/ab-testing-mistakes-kill-conversions-cover.webp",
    "featuredImageSize": {
      "width": 1600,
      "height": 1000
    },
    "figures": [
      {
        "src": "/images/blog/ab-testing-mistakes-kill-conversions-1.png",
        "alt": "Dos tarjetas (en inglés) que comparan mirar antes de tiempo, donde un alza de tres días con unas 200 conversiones se publica y luego se desvanece, con una muestra fija, definida antes de empezar y corrida un ciclo de negocio completo.",
        "caption": "Define el tamaño de muestra antes de empezar. Un 95% con unas 200 conversiones puede invertirse con 2,000.",
        "width": 1600,
        "height": 900
      },
      {
        "src": "/images/blog/ab-testing-mistakes-kill-conversions-2.png",
        "alt": "Lista (en inglés) de los siete errores de pruebas A/B que producen ganadores falsos: detener antes de tiempo, demasiadas variables, ignorar segmentos, ignorar la estacionalidad, copiar a la competencia, descuidar datos cualitativos e hipótesis pobres.",
        "caption": "Los siete errores en una lista. Cada uno convierte una prueba en una apuesta.",
        "width": 1600,
        "height": 900
      }
    ],
    "seoKeywords": [
      "errores pruebas A/B",
      "errores testing A/B",
      "testing de conversiones",
      "significancia estadística",
      "tamaño de muestra A/B",
      "mejores prácticas testing"
    ],
    "faqSchema": [
      {
        "question": "¿Cuánto tiempo debo ejecutar una prueba A/B?",
        "answer": "Ejecuta pruebas por un mínimo de 1-2 ciclos de negocio completos (usualmente 2 semanas) y hasta alcanzar significancia estadística con al menos 250-400 conversiones por variación. Nunca detengas una prueba temprano solo porque los resultados se ven bien: las victorias tempranas frecuentemente se invierten."
      },
      {
        "question": "¿Cuál es un buen tamaño de muestra para pruebas A/B?",
        "answer": "Planea al menos 250-400 conversiones por variación para detectar efectos significativos. Para tamaños de efecto más pequeños (menos del 10% de aumento), necesitarás significativamente más, frecuentemente miles de conversiones. Usa una calculadora de tamaño de muestra antes de comenzar cualquier prueba."
      },
      {
        "question": "¿Cómo sé si mis resultados de prueba A/B son válidos?",
        "answer": "Revisa tres cosas: significancia estadística (95%+ de confianza), consistencia de segmento (los resultados se mantienen en todos los tipos de dispositivo y fuentes de tráfico), y significancia práctica (el aumento es lo suficientemente grande para importar a tu negocio). Documenta factores externos que puedan influir los resultados."
      }
    ],
    "keyTakeaways": [
      {
        "title": "Nunca detengas pruebas temprano:",
        "description": "Los resultados positivos tempranos frecuentemente son ruido, así que espera tamaños de muestra completos y ciclos de negocio completos"
      },
      {
        "title": "Aísla variables:",
        "description": "Prueba una cosa a la vez a menos que tengas tráfico masivo para pruebas multivariadas apropiadas"
      },
      {
        "title": "Segmenta tus resultados:",
        "description": "Los aumentos generales pueden ocultar problemas específicos de segmento que perjudican a ciertos grupos de usuarios"
      },
      {
        "title": "Combina cualitativo y cuantitativo:",
        "description": "Usa investigación cualitativa para encontrar qué probar, pruebas A/B para validar soluciones"
      },
      {
        "title": "Escribe hipótesis reales:",
        "description": "Cada prueba debe estar conectada a datos, incluir resultados esperados y explicar el razonamiento"
      }
    ]
  },
  {
    "id": 28,
    "slug": "es-ai-overviews-seo-strategy-2026",
    "title": "Cómo los AI Overviews Están Cambiando la Estrategia SEO en 2026",
    "excerpt": "Los AI Overviews se sientan arriba de los rankings. Escribe una página que Google pueda levantar y luego checa ChatGPT, Claude, Perplexity, Gemini y Grok.",
    "author": {
      "name": "José Antonio Mijares",
      "role": "Founder & AI Strategist",
      "avatar": "/images/team/jose-mijares.png",
      "twitter": "@joseamijares"
    },
    "category": "SEO",
    "tags": [
      "AI Overviews",
      "GEO",
      "Estrategia SEO",
      "Google SGE",
      "Búsqueda Generativa",
      "SEO 2026"
    ],
    "publishedAt": "2026-01-23",
    "modifiedAt": "2026-10-27",
    "readingTime": "6 min de lectura",
    "featuredImage": "/images/blog/ai-overviews-seo-strategy-2026-cover.webp",
    "featuredImageSize": {
      "width": 1600,
      "height": 1000
    },
    "figures": [
      {
        "src": "/images/blog/ai-overviews-seo-strategy-2026-1.png",
        "alt": "Un AI Overview arriba de los resultados ordinarios de Google",
        "width": 1600,
        "height": 900
      },
      {
        "src": "/images/blog/ai-overviews-seo-strategy-2026-2.png",
        "alt": "Una página estructurada para que un Overview pueda levantar la respuesta",
        "width": 1600,
        "height": 900
      }
    ],
    "seoKeywords": [
      "AI overviews SEO",
      "optimización Google AI overview",
      "GEO generative engine optimization",
      "estrategia SEO 2026",
      "optimización búsqueda IA"
    ],
    "faqSchema": [
      {
        "question": "¿Todas las búsquedas de Google muestran un AI Overview?",
        "answer": "No. Los Overviews aparecen seguido en consultas informativas y menos en otras. No vamos a inventar un porcentaje. Busca las queries que te importan y mira. Si la caja está, tu página tiene que funcionar para ella."
      },
      {
        "question": "¿Cómo logro que me citen en AI Overviews?",
        "answer": "Responde en la primera oración. Usa schema solo donde la página es ese schema. Construye profundidad en un tema. Escribe para que un extraño pueda seguirte. Gana menciones en fuentes que Google ya cita. El schema no es un lift garantizado."
      },
      {
        "question": "¿Cuál es la diferencia entre SEO y GEO?",
        "answer": "SEO son páginas rankeadas en Google. GEO son citas en respuestas de IA: ChatGPT, Claude, Perplexity, Gemini, Grok y Google AI Overviews. Puedes rankear #1 y aun así perder al lector con la caja. Las mismas páginas deberían hacer las dos cosas. Ver /es/services/seo y /es/services/geo."
      }
    ],
    "keyTakeaways": [
      {
        "title": "La caja se sienta arriba del ranking:",
        "description": "La citación en un Overview es parte del SEO. No vamos a inventar una proporción de búsquedas."
      },
      {
        "title": "Respuesta primero:",
        "description": "El modelo levanta una oración limpia. Un párrafo de calentamiento le da el cupo a otro."
      },
      {
        "title": "El schema coincide con la página:",
        "description": "Usa FAQ, HowTo o Article cuando la página sea esa cosa. No un claim de 3-4x."
      },
      {
        "title": "Seis superficies, no una:",
        "description": "ChatGPT, Claude, Perplexity, Gemini, Grok y AI Overviews. No Copilot. No Reddit."
      },
      {
        "title": "SEO y GEO son un solo trabajo:",
        "description": "Rankeado en Google, citado en la respuesta. /es/services/seo y /es/services/geo."
      }
    ]
  },
  {
    "id": 25,
    "slug": "es-cro-best-practices-2026",
    "title": "Mejores Prácticas de CRO para 2026: La Guía Accionable",
    "excerpt": "Un checklist de CRO: primero medición, luego formularios, velocidad y orden de tests. Sin lifts inventados. Trabaja las páginas que ya tienen tráfico.",
    "author": {
      "name": "José Antonio Mijares",
      "role": "Founder & AI Strategist",
      "avatar": "/images/team/jose-mijares.png",
      "twitter": "@joseamijares"
    },
    "category": "CRO",
    "tags": [
      "CRO",
      "Mejores Prácticas",
      "Optimización de Conversiones",
      "Pruebas A/B",
      "Optimización de Formularios",
      "Velocidad de Página"
    ],
    "publishedAt": "2026-01-23",
    "modifiedAt": "2026-01-23",
    "readingTime": "6 min de lectura",
    "featuredImage": "/images/blog/cro-best-practices-2026-cover.webp",
    "featuredImageSize": {
      "width": 1600,
      "height": 1000
    },
    "figures": [
      {
        "src": "/images/blog/cro-best-practices-2026-1.png",
        "alt": "Tres columnas que clasifican los campos de un formulario (en inglés): se queda lo que la compra necesita ahora, como el email; se mueve para después de convertir empresa, puesto y teléfono; se quita lo que pide marketing, como cómo nos conociste y presupuesto.",
        "caption": "Cada campo del formulario cuesta conversiones. Deja solo lo que el siguiente paso necesita.",
        "width": 1600,
        "height": 900
      },
      {
        "src": "/images/blog/cro-best-practices-2026-2.png",
        "alt": "Tabla de puntuación ICE (en inglés): impacto, confianza y facilidad del 1 al 10 para cuatro ideas de prueba de ejemplo, sellos de confianza 22, popup de salida 21, checkout de una página 20 y descripciones de producto reescritas 17.",
        "caption": "Puntúa cada idea antes de probarla y empieza por el total más alto. Las cifras son el ejemplo del artículo, no un resultado de cliente.",
        "width": 1600,
        "height": 900
      }
    ],
    "seoKeywords": [
      "mejores prácticas CRO 2026",
      "checklist optimización conversiones",
      "tácticas CRO",
      "optimización formularios",
      "optimización velocidad página",
      "marco de testing"
    ],
    "faqSchema": [
      {
        "question": "¿Qué herramientas de CRO debo usar en 2026?",
        "answer": "Comienza con GA4 para analytics, Microsoft Clarity (gratis) para heatmaps y grabaciones de sesión, y tu plataforma de pruebas A/B existente. La herramienta importa menos que tener una recolección de datos apropiada antes de empezar a optimizar."
      },
      {
        "question": "¿Cuántos campos de formulario debo tener?",
        "answer": "Los menos posibles. Cada campo cuesta conversiones. Mantén solo lo que se requiere para el siguiente paso inmediato. Mueve los campos \"buenos de tener\" a encuestas post-conversión. Prueba eliminar campos uno a la vez y mide el impacto."
      },
      {
        "question": "¿Cómo priorizo qué pruebas ejecutar primero?",
        "answer": "Usa el marco ICE: puntúa cada idea de prueba del 1-10 en Impacto, Confianza y Facilidad. Ejecuta las pruebas con mayor puntuación primero. Este enfoque sistemático supera la priorización por instinto y te ayuda a enfocarte en experimentos de alto impacto."
      }
    ],
    "keyTakeaways": [
      {
        "title": "Fundamento de datos primero:",
        "description": "No puedes optimizar lo que no puedes medir, así que configura analytics apropiados antes de hacer pruebas"
      },
      {
        "title": "Existen victorias rápidas:",
        "description": "Optimización above-the-fold, señales de confianza y reductores de fricción frecuentemente entregan resultados inmediatos"
      },
      {
        "title": "Los formularios son costosos:",
        "description": "Cada campo cuesta conversiones; cuestiona cada input que estás pidiendo"
      },
      {
        "title": "La velocidad equivale a dinero:",
        "description": "Cada 100ms de tiempo de carga impacta tu tasa de conversión"
      },
      {
        "title": "Sistematiza el testing:",
        "description": "Usa marcos ICE/PIE para priorizar y mantén un calendario de testing consistente"
      }
    ]
  },
  {
    "id": 27,
    "slug": "es-geo-generative-engine-optimization-guide-2026",
    "title": "GEO: La Guía Completa de Optimización para Motores Generativos en 2026",
    "excerpt": "GEO es que te citen dentro de respuestas de IA: ChatGPT, Claude, Perplexity, Gemini, Grok y Google AI Overviews. En qué se diferencia del SEO y cómo hacerlo.",
    "author": {
      "name": "José Antonio Mijares",
      "role": "Founder & AI Strategist",
      "avatar": "/images/team/jose-mijares.png",
      "twitter": "@joseamijares"
    },
    "category": "SEO",
    "tags": [
      "GEO",
      "Optimización para Motores Generativos",
      "Búsqueda con IA",
      "SEO para ChatGPT",
      "Perplexity",
      "AEO",
      "Futuro de la Búsqueda"
    ],
    "publishedAt": "2026-01-23",
    "modifiedAt": "2026-01-23",
    "readingTime": "9 min de lectura",
    "featuredImage": "/images/blog/geo-generative-engine-optimization-guide-2026-cover.webp",
    "featuredImageSize": {
      "width": 1600,
      "height": 1000
    },
    "figures": [
      {
        "src": "/images/blog/geo-generative-engine-optimization-guide-2026-1.png",
        "alt": "GEO vs SEO: citas en la respuesta, no solo rankings",
        "width": 1600,
        "height": 900
      },
      {
        "src": "/images/blog/geo-generative-engine-optimization-guide-2026-2.png",
        "alt": "Las seis superficies de IA: ChatGPT, Claude, Perplexity, Gemini, Grok, AI Overviews",
        "width": 1600,
        "height": 900
      }
    ],
    "seoKeywords": [
      "optimización motores generativos",
      "GEO SEO",
      "optimización ChatGPT",
      "optimización búsqueda IA",
      "SEO Perplexity",
      "AEO answer engine optimization"
    ],
    "faqSchema": [
      {
        "question": "¿Qué es GEO y en qué se diferencia del SEO?",
        "answer": "GEO (Generative Engine Optimization) es que te citen dentro de respuestas de IA en ChatGPT, Claude, Perplexity, Gemini, Grok y Google AI Overviews. SEO son páginas rankeadas en Google. Las mismas páginas y la misma autoridad alimentan ambos. GEO no es SEO local."
      },
      {
        "question": "¿Para qué superficies de IA debo optimizar?",
        "answer": "Seis: ChatGPT, Claude, Perplexity, Gemini, Grok y Google AI Overviews. No Copilot. Reddit no es un sexto motor. Es comunidad y PR, no una superficie que tratemos como ChatGPT."
      },
      {
        "question": "¿Cómo rastro mi visibilidad en IA?",
        "answer": "Corre una lista fija de prompts de comprador en cada una de las seis superficies y anota si te nombran, a quién más nombran y qué se equivoca el modelo. Jamak registra ese trabajo en Ezeo. Una hoja basta si lo haces tú. No inventes un porcentaje objetivo."
      }
    ],
    "keyTakeaways": [
      {
        "title": "GEO es citas, no SEO local:",
        "description": "Quieres que te nombren en la respuesta en seis superficies, no rankear por un nombre de ciudad."
      },
      {
        "title": "Las seis superficies están fijas:",
        "description": "ChatGPT, Claude, Perplexity, Gemini, Grok y Google AI Overviews. No Copilot. No Reddit."
      },
      {
        "title": "Estructura la página para que un modelo la levante:",
        "description": "Respuesta primero, después el detalle. Schema solo donde la página lo gana."
      },
      {
        "title": "La autoridad son menciones en las que los modelos ya confían:",
        "description": "Tu propio blog no basta si nadie más te nombra."
      },
      {
        "title": "SEO y GEO son un solo trabajo:",
        "description": "Mismas páginas, misma autoridad. Rastrea citas; no inventes un número de lift."
      }
    ]
  },
  {
    "id": 23,
    "slug": "es-multi-platform-geo-strategy",
    "title": "GEO Multi-Plataforma: Cómo Ser Citado por ChatGPT, Perplexity y Google AI",
    "excerpt": "Que te citen en seis superficies: ChatGPT, Claude, Perplexity, Gemini, Grok y AI Overviews. Rankear no es una citación. Reddit no es un sexto motor.",
    "author": {
      "name": "José Antonio Mijares",
      "role": "Founder & AI Strategist",
      "avatar": "/images/team/jose-mijares.png",
      "twitter": "@joseamijares"
    },
    "category": "SEO",
    "tags": [
      "GEO",
      "Multi-Plataforma",
      "ChatGPT",
      "Perplexity",
      "Google AI Overview",
      "Autoridad de Entidad"
    ],
    "publishedAt": "2026-01-23",
    "modifiedAt": "2026-01-23",
    "readingTime": "6 min de lectura",
    "featuredImage": "/images/blog/multi-platform-geo-strategy-cover.webp",
    "featuredImageSize": {
      "width": 1600,
      "height": 1000
    },
    "figures": [
      {
        "src": "/images/blog/multi-platform-geo-strategy-1.png",
        "alt": "Cuatro motivos de búsqueda, mapeados a páginas, no tratados como seis motores de IA",
        "width": 1600,
        "height": 900
      },
      {
        "src": "/images/blog/multi-platform-geo-strategy-2.png",
        "alt": "Las seis superficies de GEO: ChatGPT, Claude, Perplexity, Gemini, Grok, AI Overviews",
        "width": 1600,
        "height": 900
      }
    ],
    "seoKeywords": [
      "GEO multi-plataforma",
      "optimización ChatGPT",
      "citaciones IA",
      "SEO Perplexity",
      "autoridad de entidad"
    ],
    "faqSchema": [
      {
        "question": "¿Qué plataformas cuentan como superficies de GEO?",
        "answer": "Seis: ChatGPT, Claude, Perplexity, Gemini, Grok y Google AI Overviews. No Copilot. Reddit es comunidad y PR, no un sexto motor."
      },
      {
        "question": "¿Necesito una estrategia de contenido distinta para cada herramienta de IA?",
        "answer": "No. Arregla la página una vez. Checa las seis. Una sexta reescritura del mismo artículo no es una estrategia."
      },
      {
        "question": "¿Cómo mido el GEO multi-plataforma?",
        "answer": "Corre una lista fija de queries de comprador en cada superficie. Anota si te nombran, a quién más nombran y qué se equivoca el modelo. Una hoja basta. No inventes un porcentaje de citación."
      },
      {
        "question": "¿Qué debo arreglar primero?",
        "answer": "La URL que ya rankea y no tiene hechos que un modelo pueda levantar. No un cluster de blog nuevo con la misma keyword."
      }
    ],
    "keyTakeaways": [
      {
        "title": "Seis superficies, un set de páginas:",
        "description": "ChatGPT, Claude, Perplexity, Gemini, Grok y AI Overviews."
      },
      {
        "title": "Rankear no es citar:",
        "description": "Estar en la página uno no te pone en la respuesta."
      },
      {
        "title": "Reddit no es un motor:",
        "description": "La comunidad puede ayudar. No es la sexta superficie."
      },
      {
        "title": "Los mismos nombres en todos lados:",
        "description": "About y las páginas de producto tienen que coincidir."
      },
      {
        "title": "Sin presupuesto ni tasas inventadas:",
        "description": "Checa, arregla la URL que rankea, vuelve a checar. [GEO](/es/services/geo)."
      }
    ]
  },
  {
    "id": 29,
    "slug": "es-pricing-page-psychology-conversions-2026",
    "title": "Psicología de Páginas de Precios: Qué Realmente Convierte en 2026",
    "excerpt": "Las páginas de precios fallan cuando esconden la elección. Tres niveles, una opción recomendada, features como resultados. Sin lifts inventados.",
    "author": {
      "name": "José Antonio Mijares",
      "role": "Founder & AI Strategist",
      "avatar": "/images/team/jose-mijares.png",
      "twitter": "@joseamijares"
    },
    "category": "CRO",
    "tags": [
      "Página de Precios",
      "Optimización de Conversiones",
      "Psicología",
      "Precios SaaS",
      "A/B Testing",
      "CRO"
    ],
    "publishedAt": "2026-01-23",
    "modifiedAt": "2026-01-23",
    "readingTime": "6 min de lectura",
    "featuredImage": "/images/blog/pricing-page-psychology-conversions-2026-cover.webp",
    "featuredImageSize": {
      "width": 1600,
      "height": 1000
    },
    "figures": [
      {
        "src": "/images/blog/pricing-page-psychology-conversions-2026-1.png",
        "alt": "Un layout de tres niveles con una opción recomendada destacada",
        "width": 1600,
        "height": 900
      },
      {
        "src": "/images/blog/pricing-page-psychology-conversions-2026-2.png",
        "alt": "Una decisión de precios: un tier recomendado, resultados en vez de jerga de features",
        "width": 1600,
        "height": 900
      }
    ],
    "seoKeywords": [
      "optimización página de precios",
      "psicología de precios",
      "página de precios SaaS",
      "optimización tasa de conversión",
      "mejores prácticas página de precios"
    ],
    "faqSchema": [
      {
        "question": "¿Cuántos niveles de precios debo ofrecer?",
        "answer": "Tres como máximo. Starter, un plan recomendado y enterprise. Más de tres suele significar que el producto no está claro, no que la página necesita otra card."
      },
      {
        "question": "¿Debo ocultar los precios detrás de “Contactar ventas”?",
        "answer": "Solo cuando el deal es custom: implementación, alcance o un contrato que no puede ser un número self-serve. Para un producto que la gente puede comprar sola, muestra el precio."
      },
      {
        "question": "¿Qué debo probar primero en una página de precios?",
        "answer": "Si el tier recomendado es obvio. Luego el número de niveles, copy de resultado vs. feature, y el CTA. Mide en tu tráfico. No publiques un “lift del 34%” que leíste en la página de alguien más."
      },
      {
        "question": "¿Dónde queda esto junto al trabajo de conversión?",
        "answer": "La página de precios es una página de conversión. La misma disciplina que el resto de [CRO](/es/services/cro): un cambio, una muestra real, sin prueba inventada."
      }
    ],
    "keyTakeaways": [
      {
        "title": "Haz la elección fácil:",
        "description": "tres niveles, una recomendación, resultados no jerga."
      },
      {
        "title": "Muestra el precio",
        "description": "salvo que el deal sea custom."
      },
      {
        "title": "La prueba tiene que ser verdad:",
        "description": "con nombre, con fecha y tuya. Sin Acme. Sin lifts prestados."
      },
      {
        "title": "El FAQ coincide con la página:",
        "description": "preguntas visibles, schema que coincide."
      },
      {
        "title": "Prueba en tu tráfico:",
        "description": "[CRO](/es/services/cro) es el trabajo, no un screenshot del resultado de alguien más."
      }
    ]
  },
  {
    "id": 32,
    "slug": "es-ux-design-principles-increase-engagement",
    "title": "Principios de Diseño UX Que Realmente Aumentan el Engagement",
    "excerpt": "UX que ayuda a terminar el trabajo: revelación progresiva, feedback y menos carga cognitiva. Principios para aplicar, no una métrica que inventamos.",
    "author": {
      "name": "José Antonio Mijares",
      "role": "Founder & AI Strategist",
      "avatar": "/images/team/jose-mijares.png",
      "twitter": "@joseamijares"
    },
    "category": "UX",
    "tags": [
      "Diseño UX",
      "Experiencia de Usuario",
      "Engagement",
      "Principios de Diseño"
    ],
    "publishedAt": "2026-01-23",
    "modifiedAt": "2026-01-23",
    "readingTime": "6 min de lectura",
    "featuredImage": "/images/blog/ux-design-principles-increase-engagement-cover.webp",
    "featuredImageSize": {
      "width": 1600,
      "height": 1000
    },
    "figures": [
      {
        "src": "/images/blog/ux-design-principles-increase-engagement-1.png",
        "alt": "Dos paneles (en inglés) que comparan una pantalla con todos los campos y opciones a la vez contra una que empieza simple y revela la complejidad cuando se pide, con ayuda contextual y valores por defecto.",
        "caption": "Muestra primero lo esencial y deja que la gente profundice cuando esté lista.",
        "width": 1600,
        "height": 900
      },
      {
        "src": "/images/blog/ux-design-principles-increase-engagement-2.png",
        "alt": "Tres tarjetas (en inglés) sobre retroalimentación y alcance: cada acción tiene un estado visible, los objetivos táctiles miden al menos 44px según la ley de Fitts y la llamada a la acción principal queda al alcance del pulgar en móvil.",
        "caption": "Cada acción con respuesta visible, objetivos de al menos 44px y la acción principal al alcance del pulgar.",
        "width": 1600,
        "height": 900
      }
    ],
    "seoKeywords": [
      "diseño ux",
      "experiencia de usuario",
      "engagement",
      "principios de diseño",
      "ux mexico"
    ],
    "faqSchema": [
      {
        "question": "¿Cuál es el principio de UX más importante para el engagement?",
        "answer": "Empieza con revelación progresiva: muestra solo lo necesario y revela más bajo demanda. Reduce la carga cognitiva. No es un lift garantizado. Mide tiempo en tarea y errores en tu producto."
      },
      {
        "question": "¿Cómo mido el engagement de UX efectivamente?",
        "answer": "Rastrea cinco métricas clave: tiempo en tarea (cuánto tardan las acciones principales), tasa de error, tasa de éxito de tareas, puntuaciones del System Usability Scale (SUS) y Net Promoter Score (NPS). Estas te dan una imagen completa de la usabilidad y satisfacción del usuario."
      },
      {
        "question": "¿Cuál es el tamaño mínimo de objetivo táctil para UX móvil?",
        "answer": "44 píxeles mínimo, según la Ley de Fitts. Los objetivos más pequeños aumentan las tasas de error y la frustración. También asegúrate de que las acciones importantes estén colocadas en áreas fácilmente alcanzables. Considera la \"zona del pulgar\" para interfaces móviles."
      }
    ],
    "keyTakeaways": [
      {
        "title": "El engagement es emocional:",
        "description": "Los usuarios recuerdan cómo tu producto los hizo sentir, no las características"
      },
      {
        "title": "La revelación progresiva gana:",
        "description": "No abrumes. Revela la complejidad gradualmente conforme los usuarios la necesitan"
      },
      {
        "title": "La retroalimentación es esencial:",
        "description": "Cada acción debe tener una respuesta visual inmediata"
      },
      {
        "title": "Gestiona la carga cognitiva:",
        "description": "Fragmenta la información, crea jerarquía clara y usa patrones consistentes"
      },
      {
        "title": "El mejor UX es invisible:",
        "description": "Cuando todo funciona perfectamente, los usuarios no notan el diseño"
      }
    ]
  },
  {
    "id": 30,
    "slug": "es-why-every-website-needs-llm-txt-file-2026",
    "title": "Por Qué Todo Sitio Web Necesita un Archivo llms.txt en 2026",
    "excerpt": "llms.txt es una convención propuesta, no un factor de ranking. Qué es el archivo, por qué el nombre va en plural y qué no hace.",
    "author": {
      "name": "José Antonio Mijares",
      "role": "Founder & AI Strategist",
      "avatar": "/images/team/jose-mijares.png",
      "twitter": "@joseamijares"
    },
    "category": "SEO",
    "tags": [
      "LLM",
      "SEO",
      "IA",
      "SEO Técnico",
      "Futuro de las Búsquedas"
    ],
    "publishedAt": "2026-01-23",
    "modifiedAt": "2026-01-23",
    "readingTime": "7 min de lectura",
    "featuredImage": "/images/blog/why-every-website-needs-llm-txt-file-2026-cover.webp",
    "featuredImageSize": {
      "width": 1600,
      "height": 1000
    },
    "figures": [
      {
        "src": "/images/blog/why-every-website-needs-llm-txt-file-2026-1.png",
        "alt": "Un archivo llms.txt: quién eres y qué páginas leer",
        "width": 1600,
        "height": 900
      },
      {
        "src": "/images/blog/why-every-website-needs-llm-txt-file-2026-2.png",
        "alt": "robots.txt, sitemap.xml y llms.txt: tres archivos, tres trabajos",
        "width": 1600,
        "height": 900
      }
    ],
    "seoKeywords": [
      "archivo llms.txt",
      "llm.txt",
      "llm seo",
      "seo para inteligencia artificial",
      "geo seo",
      "optimización para motores de búsqueda",
      "modelos de lenguaje",
      "visibilidad en ia",
      "futuro del seo"
    ],
    "faqSchema": [
      {
        "question": "¿Qué es un archivo llms.txt y dónde lo pongo?",
        "answer": "Un archivo llms.txt es un brief en Markdown en la raíz de tu sitio (tusitio.com/llms.txt) que le dice a un modelo de lenguaje quién eres y qué páginas leer. Jeremy Howard propuso la convención en 2024. No reemplaza a robots.txt y no es una señal de ranking de Google."
      },
      {
        "question": "¿llm.txt es lo mismo que llms.txt?",
        "answer": "No. El nombre de archivo propuesto es llms.txt (plural). llm.txt es un error común. Pon el archivo en /llms.txt. Si ya publicaste /llm.txt, consérvalo o redirígelo, pero no trates la ruta en singular como el estándar."
      },
      {
        "question": "¿Google usa llms.txt para AI Overviews?",
        "answer": "Google ha dicho que no necesita un archivo llms.txt para AI Search. Los AI Overviews usan las mismas páginas indexadas y útiles que el Search ordinario. Publica el archivo como brief para las herramientas que sí lo piden. No esperes que por sí solo mueva un ranking o una citación."
      },
      {
        "question": "¿GEO es lo mismo que SEO local?",
        "answer": "No. GEO es Generative Engine Optimization: citas dentro de respuestas de IA en ChatGPT, Claude, Perplexity, Gemini, Grok y Google AI Overviews. No es SEO geográfico ni SEO local. Un nombre de ciudad en llms.txt no reemplaza una página de ubicación ni un Perfil de Empresa de Google."
      }
    ],
    "keyTakeaways": [
      {
        "title": "El archivo es llms.txt, no llm.txt:",
        "description": "La ruta propuesta es /llms.txt. Trata /llm.txt como un typo, no como el estándar."
      },
      {
        "title": "Es una convención propuesta:",
        "description": "Jeremy Howard publicó la spec en 2024. No es un factor de ranking y Google ha dicho que no necesita el archivo para AI Search."
      },
      {
        "title": "GEO no es SEO local:",
        "description": "GEO significa citas en respuestas de IA. Poner una ubicación en llms.txt no hace SEO local."
      },
      {
        "title": "Mantén el archivo corto y verdadero:",
        "description": "Quién eres, qué vendes, qué páginas importan. Sin métricas inventadas. Sin teléfonos falsos."
      },
      {
        "title": "El archivo es el mapa, no el trabajo:",
        "description": "Las citas siguen viniendo de páginas, estructura y autoridad. Ese trabajo es GEO."
      }
    ]
  },
  {
    "id": 11,
    "slug": "multi-platform-geo-strategy",
    "title": "Multi-Platform GEO: How to Get Cited by ChatGPT, Perplexity, and Google AI",
    "excerpt": "Get cited on six surfaces: ChatGPT, Claude, Perplexity, Gemini, Grok, and AI Overviews. Rank is not a citation. Reddit is not a sixth engine.",
    "author": {
      "name": "José Antonio Mijares",
      "role": "Founder & AI Strategist",
      "avatar": "/images/team/jose-mijares.png",
      "twitter": "@joseamijares"
    },
    "category": "SEO",
    "tags": [
      "GEO",
      "Multi-Platform",
      "ChatGPT",
      "Perplexity",
      "Google AI Overview",
      "Entity Authority"
    ],
    "publishedAt": "2026-01-14",
    "modifiedAt": "2026-01-14",
    "readingTime": "6 min read",
    "featuredImage": "/images/blog/multi-platform-geo-strategy-cover.webp",
    "featuredImageSize": {
      "width": 1600,
      "height": 1000
    },
    "figures": [
      {
        "src": "/images/blog/multi-platform-geo-strategy-1.png",
        "alt": "Four reasons people search, mapped to pages, not treated as six AI engines",
        "width": 1600,
        "height": 900
      },
      {
        "src": "/images/blog/multi-platform-geo-strategy-2.png",
        "alt": "The six GEO surfaces: ChatGPT, Claude, Perplexity, Gemini, Grok, AI Overviews",
        "width": 1600,
        "height": 900
      }
    ],
    "seoKeywords": [
      "multi-platform GEO",
      "ChatGPT optimization",
      "AI citations",
      "Perplexity SEO",
      "entity authority"
    ],
    "faqSchema": [
      {
        "question": "Which platforms count as GEO surfaces?",
        "answer": "Six: ChatGPT, Claude, Perplexity, Gemini, Grok, and Google AI Overviews. Not Copilot. Reddit is community and PR, not a sixth engine."
      },
      {
        "question": "Do I need a separate content strategy for each AI tool?",
        "answer": "No. Fix the page once. Check all six. A sixth rewrite of the same article is not a strategy."
      },
      {
        "question": "How do I measure multi-platform GEO?",
        "answer": "Run a fixed list of buyer queries on each surface. Record named or not, who else is named, and what the model gets wrong. A sheet is enough. Do not invent a citation percentage."
      },
      {
        "question": "What should I fix first?",
        "answer": "The URL that already ranks and has no facts a model can lift. Not a new blog cluster on the same keyword."
      }
    ],
    "keyTakeaways": [
      {
        "title": "Six surfaces, one set of pages:",
        "description": "ChatGPT, Claude, Perplexity, Gemini, Grok, and AI Overviews."
      },
      {
        "title": "Rank is not a cite:",
        "description": "Page one does not put you in the answer."
      },
      {
        "title": "Reddit is not an engine:",
        "description": "Community can help. It is not the sixth surface."
      },
      {
        "title": "Same names everywhere:",
        "description": "About and the product pages have to agree."
      },
      {
        "title": "No invented budget or rates:",
        "description": "Check, fix the ranking URL, check again. [GEO](/services/geo)."
      }
    ]
  },
  {
    "id": 9,
    "slug": "ab-testing-mistakes-kill-conversions",
    "title": "A/B Testing Mistakes That Kill Your Conversions",
    "excerpt": "Seven A/B testing mistakes that produce false winners: stopping early, testing everything at once, ignoring segments. How to avoid them.",
    "author": {
      "name": "José Antonio Mijares",
      "role": "Founder & AI Strategist",
      "avatar": "/images/team/jose-mijares.png",
      "twitter": "@joseamijares"
    },
    "category": "CRO",
    "tags": [
      "A/B Testing",
      "CRO",
      "Conversion Optimization",
      "Statistical Significance",
      "Testing Strategy",
      "Experimentation"
    ],
    "publishedAt": "2026-01-13",
    "modifiedAt": "2026-01-13",
    "readingTime": "7 min read",
    "featuredImage": "/images/blog/ab-testing-mistakes-kill-conversions-cover.webp",
    "featuredImageSize": {
      "width": 1600,
      "height": 1000
    },
    "figures": [
      {
        "src": "/images/blog/ab-testing-mistakes-kill-conversions-1.png",
        "alt": "Two cards comparing an early peek, where a three-day lift at about 200 conversions ships and later fades, with a locked sample, where the sample size is set before the test and the test runs a full business cycle.",
        "caption": "Set the sample size before the test starts. A 95% read at about 200 conversions can reverse at 2,000.",
        "width": 1600,
        "height": 900
      },
      {
        "src": "/images/blog/ab-testing-mistakes-kill-conversions-2.png",
        "alt": "List of the seven A/B testing mistakes that produce false winners: stopping too early, testing too many variables, ignoring segmentation, ignoring seasonality, copying competitors, neglecting qualitative data and poor hypotheses.",
        "caption": "The seven mistakes in one list. Each one turns a test into a guess.",
        "width": 1600,
        "height": 900
      }
    ],
    "seoKeywords": [
      "ab testing mistakes",
      "a/b testing errors",
      "conversion testing",
      "statistical significance",
      "ab test sample size",
      "testing best practices"
    ],
    "faqSchema": [
      {
        "question": "How long should I run an A/B test?",
        "answer": "Run tests for a minimum of 1-2 full business cycles (usually 2 weeks) and until you reach statistical significance with at least 250-400 conversions per variation. Never stop a test early just because results look good: early wins often flip."
      },
      {
        "question": "What's a good sample size for A/B testing?",
        "answer": "Plan for at least 250-400 conversions per variation for detecting meaningful effects. For smaller effect sizes (under 10% lift), you'll need significantly more, often thousands of conversions. Use a sample size calculator before starting any test."
      },
      {
        "question": "How do I know if my A/B test results are valid?",
        "answer": "Check three things: statistical significance (95%+ confidence), segment consistency (results hold across device types and traffic sources), and practical significance (the lift is large enough to matter for your business). Document external factors that might influence results."
      }
    ],
    "keyTakeaways": [
      {
        "title": "Never stop tests early:",
        "description": "Early positive results are often noise, so wait for full sample sizes and complete business cycles"
      },
      {
        "title": "Isolate variables:",
        "description": "Test one thing at a time unless you have massive traffic for proper multivariate testing"
      },
      {
        "title": "Segment your results:",
        "description": "Overall lifts can hide segment-specific problems that hurt certain user groups"
      },
      {
        "title": "Combine qual and quant:",
        "description": "Use qualitative research to find what to test, A/B testing to validate solutions"
      },
      {
        "title": "Write real hypotheses:",
        "description": "Every test should be connected to data, include expected outcomes, and explain the rationale"
      }
    ]
  },
  {
    "id": 8,
    "slug": "cro-best-practices-2026",
    "title": "CRO Best Practices for 2026: The Actionable Playbook",
    "excerpt": "A CRO checklist: fix measurement, then forms, speed, and test order. No invented conversion lifts. Work the pages that already get traffic.",
    "author": {
      "name": "José Antonio Mijares",
      "role": "Founder & AI Strategist",
      "avatar": "/images/team/jose-mijares.png",
      "twitter": "@joseamijares"
    },
    "category": "CRO",
    "tags": [
      "CRO",
      "Best Practices",
      "Conversion Optimization",
      "A/B Testing",
      "Form Optimization",
      "Page Speed"
    ],
    "publishedAt": "2026-01-13",
    "modifiedAt": "2026-01-13",
    "readingTime": "6 min read",
    "featuredImage": "/images/blog/cro-best-practices-2026-cover.webp",
    "featuredImageSize": {
      "width": 1600,
      "height": 1000
    },
    "figures": [
      {
        "src": "/images/blog/cro-best-practices-2026-1.png",
        "alt": "Three columns sorting form fields: keep what the purchase or service needs now, such as email; move nice-to-have fields like company, job title and phone to after conversion; drop fields marketing wants, such as how did you hear about us and budget.",
        "caption": "Every form field costs conversions. Keep only what the next step needs.",
        "width": 1600,
        "height": 900
      },
      {
        "src": "/images/blog/cro-best-practices-2026-2.png",
        "alt": "ICE scoring table: impact, confidence and ease each scored 1 to 10 for four example test ideas, trust badges 22, exit-intent popup 21, one-page checkout 20 and rewritten product descriptions 17.",
        "caption": "Score each test idea before you run it and start with the highest total. The scores are the article's example, not a client result.",
        "width": 1600,
        "height": 900
      }
    ],
    "seoKeywords": [
      "cro best practices 2026",
      "conversion optimization checklist",
      "cro tactics",
      "form optimization",
      "page speed optimization",
      "testing framework"
    ],
    "faqSchema": [
      {
        "question": "What CRO tools should I use in 2026?",
        "answer": "Start with GA4 for analytics, Microsoft Clarity (free) for heatmaps and session recordings, and your existing A/B testing platform. The tool matters less than having proper data collection in place before you start optimizing."
      },
      {
        "question": "How many form fields should I have?",
        "answer": "As few as possible. Every field costs conversions. Keep only what's required for the immediate next step. Move \"nice to have\" fields to post-conversion surveys. Test removing fields one at a time and measure the impact."
      },
      {
        "question": "How do I prioritize which tests to run first?",
        "answer": "Use the ICE framework: score each test idea 1-10 on Impact, Confidence, and Ease. Run the highest-scoring tests first. This systematic approach beats gut-feel prioritization and helps you focus on high-impact experiments."
      }
    ],
    "keyTakeaways": [
      {
        "title": "Data foundation first:",
        "description": "You can't optimize what you can't measure, so set up proper analytics before testing"
      },
      {
        "title": "Quick wins exist:",
        "description": "Above-the-fold optimization, trust signals, and friction reducers often deliver immediate results"
      },
      {
        "title": "Forms are expensive:",
        "description": "Every field costs conversions; question every input you're asking for"
      },
      {
        "title": "Speed equals money:",
        "description": "Every 100ms of load time impacts your conversion rate"
      },
      {
        "title": "Systematize testing:",
        "description": "Use ICE/PIE frameworks to prioritize and maintain a consistent testing calendar"
      }
    ]
  },
  {
    "id": 6,
    "slug": "geo-generative-engine-optimization-guide-2026",
    "title": "GEO: The Complete Guide to Generative Engine Optimization in 2026",
    "excerpt": "GEO is getting cited inside AI answers: ChatGPT, Claude, Perplexity, Gemini, Grok, and Google AI Overviews. How the work differs from SEO, and how to do it.",
    "author": {
      "name": "José Antonio Mijares",
      "role": "Founder & AI Strategist",
      "avatar": "/images/team/jose-mijares.png",
      "twitter": "@joseamijares"
    },
    "category": "SEO",
    "tags": [
      "GEO",
      "Generative Engine Optimization",
      "AI Search",
      "ChatGPT SEO",
      "Perplexity",
      "AEO",
      "Future of Search"
    ],
    "publishedAt": "2026-01-11",
    "modifiedAt": "2026-01-11",
    "readingTime": "9 min read",
    "featuredImage": "/images/blog/geo-generative-engine-optimization-guide-2026-cover.webp",
    "featuredImageSize": {
      "width": 1600,
      "height": 1000
    },
    "figures": [
      {
        "src": "/images/blog/geo-generative-engine-optimization-guide-2026-1.png",
        "alt": "GEO vs SEO: citations in the answer, not only rankings",
        "width": 1600,
        "height": 900
      },
      {
        "src": "/images/blog/geo-generative-engine-optimization-guide-2026-2.png",
        "alt": "The six AI surfaces: ChatGPT, Claude, Perplexity, Gemini, Grok, AI Overviews",
        "width": 1600,
        "height": 900
      }
    ],
    "seoKeywords": [
      "generative engine optimization",
      "GEO SEO",
      "ChatGPT optimization",
      "AI search optimization",
      "Perplexity SEO",
      "AEO answer engine optimization"
    ],
    "faqSchema": [
      {
        "question": "What is GEO and how is it different from SEO?",
        "answer": "GEO (Generative Engine Optimization) is getting cited inside AI answers on ChatGPT, Claude, Perplexity, Gemini, Grok, and Google AI Overviews. SEO is ranked pages in Google. The same pages and authority feed both. GEO is not local SEO."
      },
      {
        "question": "Which AI surfaces should I optimize for?",
        "answer": "Six: ChatGPT, Claude, Perplexity, Gemini, Grok, and Google AI Overviews. Not Copilot. Reddit is not a sixth engine. It is community and PR, not a surface we treat like ChatGPT."
      },
      {
        "question": "How do I track AI visibility?",
        "answer": "Run a fixed list of buyer prompts on each of the six surfaces and record whether you are named, who else is named, and what the model gets wrong. Jamak logs that work in Ezeo. A sheet is enough if you are doing it yourself. Do not invent a target percentage."
      }
    ],
    "keyTakeaways": [
      {
        "title": "GEO is citations, not local SEO:",
        "description": "You want to be named in the answer on six surfaces, not ranked for a city name."
      },
      {
        "title": "The six surfaces are fixed:",
        "description": "ChatGPT, Claude, Perplexity, Gemini, Grok, and Google AI Overviews. Not Copilot. Not Reddit."
      },
      {
        "title": "Structure the page so a model can lift it:",
        "description": "Answer first, then detail. Schema only where the page earns it."
      },
      {
        "title": "Authority is mentions the models already trust:",
        "description": "Your own blog is not enough if no one else names you."
      },
      {
        "title": "SEO and GEO are one job:",
        "description": "Same pages, same authority. Track citations; do not invent a lift number."
      }
    ]
  },
  {
    "id": 4,
    "slug": "ai-overviews-seo-strategy-2026",
    "title": "How AI Overviews Are Changing SEO Strategy in 2026",
    "excerpt": "AI Overviews sit above the rankings. Write a page Google can lift, then check ChatGPT, Claude, Perplexity, Gemini, and Grok.",
    "author": {
      "name": "José Antonio Mijares",
      "role": "Founder & AI Strategist",
      "avatar": "/images/team/jose-mijares.png",
      "twitter": "@joseamijares"
    },
    "category": "SEO",
    "tags": [
      "AI Overviews",
      "GEO",
      "SEO Strategy",
      "Google SGE",
      "Generative Search",
      "2026 SEO"
    ],
    "publishedAt": "2026-01-10",
    "modifiedAt": "2026-10-27",
    "readingTime": "6 min read",
    "featuredImage": "/images/blog/ai-overviews-seo-strategy-2026-cover.webp",
    "featuredImageSize": {
      "width": 1600,
      "height": 1000
    },
    "figures": [
      {
        "src": "/images/blog/ai-overviews-seo-strategy-2026-1.png",
        "alt": "An AI Overview above ordinary Google results",
        "width": 1600,
        "height": 900
      },
      {
        "src": "/images/blog/ai-overviews-seo-strategy-2026-2.png",
        "alt": "A page structured so an Overview can lift the answer",
        "width": 1600,
        "height": 900
      }
    ],
    "seoKeywords": [
      "AI overviews SEO",
      "Google AI overview optimization",
      "GEO generative engine optimization",
      "SEO strategy 2026",
      "AI search optimization"
    ],
    "faqSchema": [
      {
        "question": "Do all Google searches show an AI Overview?",
        "answer": "No. Overviews show up often on informational queries and less often on others. We will not invent a percentage. Search the queries you care about and look. If the box is there, your page has to work for it."
      },
      {
        "question": "How do I get cited in AI Overviews?",
        "answer": "Answer in the first sentence. Use schema only where the page is that schema. Build depth on one topic. Write so a stranger can follow it. Earn mentions on sources Google already cites. Schema is not a guaranteed lift."
      },
      {
        "question": "What is the difference between SEO and GEO?",
        "answer": "SEO is ranked pages in Google. GEO is citations in AI answers: ChatGPT, Claude, Perplexity, Gemini, Grok, and Google AI Overviews. You can rank #1 and still lose the reader to the box. The same pages should do both. See /services/seo and /services/geo."
      }
    ],
    "keyTakeaways": [
      {
        "title": "The box sits above the ranking:",
        "description": "Citation in an Overview is part of SEO. We will not invent a share of searches."
      },
      {
        "title": "Answer first:",
        "description": "The model lifts a clean sentence. A warm-up paragraph gives the slot to someone else."
      },
      {
        "title": "Schema matches the page:",
        "description": "Use FAQ, HowTo, or Article when the page is that thing. Not a 3-4x claim."
      },
      {
        "title": "Six surfaces, not one:",
        "description": "ChatGPT, Claude, Perplexity, Gemini, Grok, and AI Overviews. Not Copilot. Not Reddit."
      },
      {
        "title": "SEO and GEO are one job:",
        "description": "Ranked in Google, cited in the answer. /services/seo and /services/geo."
      }
    ]
  },
  {
    "id": 5,
    "slug": "pricing-page-psychology-conversions-2026",
    "title": "Pricing Page Psychology: What Actually Converts in 2026",
    "excerpt": "Pricing pages fail when they hide the choice. Three tiers, a recommended option, features as outcomes. No invented lift numbers.",
    "author": {
      "name": "José Antonio Mijares",
      "role": "Founder & AI Strategist",
      "avatar": "/images/team/jose-mijares.png",
      "twitter": "@joseamijares"
    },
    "category": "CRO",
    "tags": [
      "Pricing Page",
      "Conversion Optimization",
      "Psychology",
      "SaaS Pricing",
      "A/B Testing",
      "CRO"
    ],
    "publishedAt": "2026-01-10",
    "modifiedAt": "2026-01-10",
    "readingTime": "6 min read",
    "featuredImage": "/images/blog/pricing-page-psychology-conversions-2026-cover.webp",
    "featuredImageSize": {
      "width": 1600,
      "height": 1000
    },
    "figures": [
      {
        "src": "/images/blog/pricing-page-psychology-conversions-2026-1.png",
        "alt": "A three-tier pricing layout with one recommended option highlighted",
        "width": 1600,
        "height": 900
      },
      {
        "src": "/images/blog/pricing-page-psychology-conversions-2026-2.png",
        "alt": "A pricing decision: one recommended tier, outcomes instead of feature jargon",
        "width": 1600,
        "height": 900
      }
    ],
    "seoKeywords": [
      "pricing page optimization",
      "pricing psychology",
      "SaaS pricing page",
      "conversion rate optimization",
      "pricing page best practices"
    ],
    "faqSchema": [
      {
        "question": "How many pricing tiers should I offer?",
        "answer": "Three at most. Starter, a recommended plan, and enterprise. More than three usually means the product is unclear, not that the page needs another card."
      },
      {
        "question": "Should I hide pricing behind “Contact sales”?",
        "answer": "Only when the deal is custom: implementation, scope, or a contract that cannot be a self-serve number. For a product people can buy alone, show the price."
      },
      {
        "question": "What should I test first on a pricing page?",
        "answer": "Whether the recommended tier is obvious. Then the number of tiers, outcome vs. feature copy, and the CTA. Measure on your traffic. Do not ship a “34% lift” you read on someone else’s page."
      },
      {
        "question": "Where does this sit next to conversion work?",
        "answer": "The pricing page is a conversion page. The same discipline as the rest of [CRO](/services/cro): one change, a real sample, no invented proof."
      }
    ],
    "keyTakeaways": [
      {
        "title": "Make the choice easy:",
        "description": "three tiers, one recommendation, outcomes not jargon."
      },
      {
        "title": "Show the price",
        "description": "unless the deal is custom."
      },
      {
        "title": "Proof has to be true:",
        "description": "named, dated, and yours. No Acme. No borrowed lift."
      },
      {
        "title": "FAQ matches the page:",
        "description": "visible questions, matching schema."
      },
      {
        "title": "Test on your traffic:",
        "description": "[CRO](/services/cro) is the work, not a screenshot of someone else’s result."
      }
    ]
  },
  {
    "id": 1,
    "slug": "why-every-website-needs-llm-txt-file-2026",
    "title": "Why Every Website Needs an llms.txt File in 2026",
    "excerpt": "llms.txt is a proposed convention, not a ranking factor. Here is what the file actually is, why the name is plural, and what it does not do.",
    "author": {
      "name": "José Antonio Mijares",
      "role": "Founder & AI Strategist",
      "avatar": "/images/team/jose-mijares.png",
      "twitter": "@joseamijares"
    },
    "category": "SEO",
    "tags": [
      "LLM",
      "SEO",
      "AI",
      "Technical SEO",
      "Future of Search"
    ],
    "publishedAt": "2025-01-10",
    "modifiedAt": "2025-01-10",
    "readingTime": "7 min read",
    "featuredImage": "/images/blog/why-every-website-needs-llm-txt-file-2026-cover.webp",
    "featuredImageSize": {
      "width": 1600,
      "height": 1000
    },
    "figures": [
      {
        "src": "/images/blog/why-every-website-needs-llm-txt-file-2026-1.png",
        "alt": "An llms.txt file: who you are and which pages to read",
        "width": 1600,
        "height": 900
      },
      {
        "src": "/images/blog/why-every-website-needs-llm-txt-file-2026-2.png",
        "alt": "robots.txt, sitemap.xml, and llms.txt: three files, three jobs",
        "width": 1600,
        "height": 900
      }
    ],
    "seoKeywords": [
      "llms.txt",
      "llm.txt",
      "llms seo",
      "ai seo",
      "geo seo",
      "search engine optimization",
      "large language models",
      "ai visibility",
      "future of seo"
    ],
    "faqSchema": [
      {
        "question": "What is an llms.txt file and where do I put it?",
        "answer": "An llms.txt file is a Markdown brief at the root of your site (yoursite.com/llms.txt) that tells a language model who you are and which pages to read. Jeremy Howard proposed the convention in 2024. It is not a robots.txt replacement and it is not a Google ranking signal."
      },
      {
        "question": "Is llm.txt the same as llms.txt?",
        "answer": "No. The proposed filename is llms.txt (plural). llm.txt is a common misspelling. Put the file at /llms.txt. If you already published /llm.txt, keep it or redirect it, but do not treat the singular path as the standard."
      },
      {
        "question": "Does Google use llms.txt for AI Overviews?",
        "answer": "Google has said it does not need an llms.txt file for AI Search. AI Overviews draw on the same indexed, helpful pages as ordinary Search. Ship the file as a brief for tools that fetch it. Do not expect it to move a ranking or a citation on its own."
      },
      {
        "question": "Is GEO the same as local SEO?",
        "answer": "No. GEO is Generative Engine Optimization: citations inside AI answers on ChatGPT, Claude, Perplexity, Gemini, Grok, and Google AI Overviews. It is not geographic or local SEO. A city name in llms.txt does not replace a location page or a Google Business Profile."
      }
    ],
    "keyTakeaways": [
      {
        "title": "The file is llms.txt, not llm.txt:",
        "description": "The proposed path is /llms.txt. Treat /llm.txt as a typo, not the standard."
      },
      {
        "title": "It is a proposed convention:",
        "description": "Jeremy Howard published the spec in 2024. It is not a ranking factor and Google has said it does not need the file for AI Search."
      },
      {
        "title": "GEO is not local SEO:",
        "description": "GEO means citations in AI answers. Putting a location in llms.txt does not do local SEO."
      },
      {
        "title": "Keep the file short and true:",
        "description": "Who you are, what you sell, which pages matter. No invented metrics. No fake phone numbers."
      },
      {
        "title": "The file is a map, not the work:",
        "description": "Citations still come from pages, structure, and authority. That work is GEO."
      }
    ]
  },
  {
    "id": 3,
    "slug": "ux-design-principles-increase-engagement",
    "title": "UX Design Principles That Actually Increase Engagement",
    "excerpt": "UX that helps people finish the job: progressive disclosure, feedback, and less cognitive load. Principles to apply, not a metric we invented.",
    "author": {
      "name": "José Antonio Mijares",
      "role": "Founder & AI Strategist",
      "avatar": "/images/team/jose-mijares.png",
      "twitter": "@joseamijares"
    },
    "category": "UX",
    "tags": [
      "UX Design",
      "User Experience",
      "Engagement",
      "Design Principles"
    ],
    "publishedAt": "2025-01-05",
    "modifiedAt": "2025-01-05",
    "readingTime": "6 min read",
    "featuredImage": "/images/blog/ux-design-principles-increase-engagement-cover.webp",
    "featuredImageSize": {
      "width": 1600,
      "height": 1000
    },
    "figures": [
      {
        "src": "/images/blog/ux-design-principles-increase-engagement-1.png",
        "alt": "Two panels comparing a screen that shows every field and option at once with one that starts simple and reveals complexity on demand, through contextual help and smart defaults.",
        "caption": "Show the essentials first and let people dig deeper when they are ready.",
        "width": 1600,
        "height": 900
      },
      {
        "src": "/images/blog/ux-design-principles-increase-engagement-2.png",
        "alt": "Three cards on feedback and reach: every action gets a visible state, touch targets are at least 44px under Fitts's law, and the main call to action sits in the thumb zone on mobile.",
        "caption": "Give every action a visible response, make targets at least 44px, and keep the main action within thumb reach.",
        "width": 1600,
        "height": 900
      }
    ],
    "seoKeywords": [
      "ux design",
      "user experience",
      "engagement",
      "design principles"
    ],
    "faqSchema": [
      {
        "question": "What's the most important UX principle for engagement?",
        "answer": "Start with progressive disclosure: show only what is needed, then reveal more on demand. It reduces cognitive load. It is not a guaranteed lift. Measure time on task and errors on your product."
      },
      {
        "question": "How do I measure UX engagement effectively?",
        "answer": "Track five key metrics: time on task (how long core actions take), error rate, task success rate, System Usability Scale (SUS) scores, and Net Promoter Score (NPS). These give you a complete picture of usability and user satisfaction."
      },
      {
        "question": "What's the minimum touch target size for mobile UX?",
        "answer": "44 pixels minimum, per Fitts's Law. Smaller targets increase error rates and frustration. Also ensure important actions are placed in easily reachable areas. Consider the \"thumb zone\" for mobile interfaces."
      }
    ],
    "keyTakeaways": [
      {
        "title": "Engagement is emotional:",
        "description": "Users remember how your product made them feel, not the features"
      },
      {
        "title": "Progressive disclosure wins:",
        "description": "Don't overwhelm. Reveal complexity gradually as users need it"
      },
      {
        "title": "Feedback is essential:",
        "description": "Every action should have immediate visual response"
      },
      {
        "title": "Manage cognitive load:",
        "description": "Chunk information, create clear hierarchy, and use consistent patterns"
      },
      {
        "title": "The best UX is invisible:",
        "description": "When everything works perfectly, users don't notice the design"
      }
    ]
  }
];

export const getFeaturedPosts = () => blogPosts.slice(0, 3);

export const getPostBySlug = (slug) => blogPosts.find(post => post.slug === slug);

export const getRelatedPosts = (currentPostId, category) => {
  return blogPosts
    .filter(post => post.id !== currentPostId && post.category === category)
    .slice(0, 3);
};
